export const regionStore = {
  status: 'success',
  data: {
    sections: [
      'special_offers',
      'subscriptions',
      'subscription_groups',
      'web_subscription_groups',
      'bundle_banners',
      'token_packs',
      'tokens',
      'mini_classes',
    ],
    availableFilters: [
      {
        id: 1,
        name: '分類一',
      },
      {
        id: 2,
        name: 'This is Empty',
      },
      {
        id: 5,
        name: '佛佛 TEST filter',
      },
      {
        id: 7,
        name: 'Arthur test 國中 filter',
      },
      {
        id: 8,
        name: 'Arthur test  特考 filter',
      },
      {
        id: 9,
        name: 'Arthur test  作文批改 filter',
      },
      {
        id: 11,
        name: '高中 (High School Only)',
      },
      {
        id: 12,
        name: '國中 (Junior School Only)',
      },
    ],
    bundleBanners: [
      {
        id: 712,
        name: '課程B single subscription',
        subName: '課程B single subscription',
        description: '課程B single subscription',
        longDescription: '課程B single subscription',
        designatedQuestion: 20,
        planType: 'renewable',
        priority: 9999,
        currency: 'TWD',
        displayCurrency: 'NT$ ',
        isSpecialOffer: false,
        isFreeTrial: false,
        isTimeLimited: false,
        registerWithinDays: -1,
        preDiscountPrice: 0,
        expiredAt: '2021-08-25 23:13:00 +0800',
        questionQuota: 0,
        isUnlimited: false,
        billingCyclePerDays: 0,
        billingCyclePerMonths: 1,
        contractPeriod: 0,
        isContract: false,
        paymentMethods: [
          {
            id: 2175,
            platform: 'web',
            sku: 'tw_web_starter_limited_monthly_p600_q0_2021aug25_9cbc64',
            methodType: 'braintree',
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            price: 600,
            isFocus: false,
            isActive: true,
            renewable: true,
            needsInvoice: true,
          },
        ],
        deliveryType: ['shipping', 'in_store_pickup'],
        isFocus: false,
        purchasable: true,
        discountSupportVendor: [],
        isAddon: false,
        isSubscribed: false,
        hasMorePlans: false,
        sellingTypes: ['course_subscription'],
        freeTrialDays: 0,
        previousPackageType: 'renewable_subscription',
        isSelected: false,
        imageUrl:
          'https://s3-ap-southeast-1.amazonaws.com/attachments.test-consolidation.appedu.co/banners/images/000/000/084/original/_82___Brand__Sunset_the__Mission__page_-_Announcement_image.png?1646381434',
        url: 'https://dragonfruit.snapask.co/tw/purchase/2175',
      },
      {
        id: 414,
        name: 'Subscription- 50 Q a month + Study Planet 1 month',
        subName: '(sub-name)Subscription- 50 Q a month',
        description:
          '(Description)Subscription- 50 Q a month + Study Planet 1 month',
        longDescription: '(Long Description)Subscription- 50 Q a month',
        designatedQuestion: 20,
        planType: 'renewable',
        priority: 1002,
        currency: 'TWD',
        displayCurrency: 'NT$ ',
        isSpecialOffer: false,
        isFreeTrial: false,
        isTimeLimited: false,
        registerWithinDays: -1,
        preDiscountPrice: 0,
        expiredAt: '2020-08-22 11:40:00 +0800',
        questionQuota: 9999999,
        isUnlimited: true,
        billingCyclePerDays: 0,
        billingCyclePerMonths: 1,
        contractPeriod: 0,
        isContract: false,
        paymentMethods: [
          {
            id: 1570,
            platform: 'web',
            sku: 'tw_web_starter_limited_monthly_p100_q4_2020sep16_4c23e5',
            methodType: 'braintree',
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            price: 2000,
            isFocus: false,
            isActive: true,
            renewable: true,
            introductoryPrice: 1900,
            needsInvoice: true,
          },
          {
            id: 1676,
            platform: 'web',
            sku: 'tw_web_starter_limited_monthly_p2000_q50_2020dec16_f0e95f',
            methodType: 'neweb',
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            price: 2000,
            isFocus: false,
            isActive: true,
            renewable: false,
            needsInvoice: true,
          },
        ],
        deliveryType: ['shipping', 'in_store_pickup'],
        isFocus: true,
        purchasable: false,
        discountSupportVendor: [],
        isAddon: true,
        isSubscribed: false,
        hasMorePlans: false,
        sellingTypes: ['token_subscription'],
        freeTrialDays: 0,
        previousPackageType: 'renewable_subscription',
        isSelected: false,
        imageUrl:
          'https://s3-ap-southeast-1.amazonaws.com/attachments.test-consolidation.appedu.co/banners/images/000/000/081/original/offset_comp_772626-opt.jpg?1638073495',
        url: 'https://dragonfruit.snapask.co/tw/purchase/1570',
      },
      {
        id: 271,
        name: '(name) Subscription- unlimited Q 3 month',
        subName: '(sub-name)Subscription- unlimited Q 3 month',
        description: '(Description)Subscription- unlimited Q 3 month',
        longDescription: '(Long Description)Subscription- unlimited Q 3 month',
        highlight: '激推',
        designatedQuestion: 20,
        planType: 'renewable',
        priority: 1001,
        currency: 'TWD',
        displayCurrency: 'NT$ ',
        isSpecialOffer: false,
        isFreeTrial: false,
        isTimeLimited: false,
        registerWithinDays: -1,
        preDiscountPrice: 0,
        expiredAt: '2021-07-31 23:59:00 +0800',
        questionQuota: 9999999,
        isUnlimited: true,
        billingCyclePerDays: 0,
        billingCyclePerMonths: 3,
        contractPeriod: 0,
        isContract: false,
        paymentMethods: [
          {
            id: 450,
            platform: 'web',
            sku:
              'tw_web_premium_unlimited_3monthly_p6590_qunl_2018mar31_ac60e8',
            methodType: 'braintree',
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            price: 3000,
            isFocus: false,
            isActive: true,
            renewable: true,
            introductoryPrice: 2400,
            needsInvoice: true,
          },
          {
            id: 451,
            platform: 'web',
            sku:
              'tw_web_premium_unlimited_3monthly_p6590_qunl_2018mar31_cf4f77',
            methodType: 'neweb',
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            price: 3000,
            isFocus: false,
            isActive: true,
            renewable: false,
            needsInvoice: true,
          },
        ],
        deliveryType: ['shipping', 'in_store_pickup'],
        isFocus: true,
        purchasable: false,
        discountSupportVendor: ['lgu'],
        isAddon: true,
        isSubscribed: false,
        hasMorePlans: false,
        sellingTypes: ['token_subscription'],
        freeTrialDays: 0,
        previousPackageType: 'renewable_subscription',
        isSelected: false,
        imageUrl:
          'https://s3-ap-southeast-1.amazonaws.com/attachments.test-consolidation.appedu.co/banners/images/000/000/060/original/1528116186201pp37p78550.jpg?1593665225',
        url: 'https://dragonfruit.snapask.co/tw/purchase/450',
      },
    ],
    tokenPacks: [
      {
        id: 4,
        title: 'All subjects available pack',
        description: 'lalala this is for all subjects',
        highlight: 'Highly Recommended?',
        lowestPlanPrice: 299,
        plans: [
          {
            id: 542,
            name: 'intro - PlanBundle1 (all subject) 3 session',
            subName: 'intro - plan_bundle_1_3_session',
            description: 'introductory price test',
            longDescription: 'test',
            designatedQuestion: 20,
            planType: 'consumable',
            priority: 9999,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: -1,
            preDiscountPrice: 0,
            expiredAt: '2020-06-18 10:17:00 +0800',
            questionQuota: 3,
            isUnlimited: false,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 1200,
            contractPeriod: 0,
            isContract: false,
            paymentMethods: [
              {
                id: 1378,
                platform: 'web',
                sku:
                  'tw_web_starter_limited_1200monthly_p300_q0_2020jun18_3d2609',
                methodType: 'braintree',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 300,
                isFocus: false,
                isActive: true,
                renewable: false,
                needsInvoice: true,
              },
              {
                id: 1522,
                platform: 'web',
                sku:
                  'tw_web_starter_limited_1200monthly_p299_q3_2020sep03_290522',
                methodType: 'neweb',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 299,
                isFocus: false,
                isActive: true,
                renewable: false,
                needsInvoice: true,
              },
            ],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: false,
            purchasable: true,
            discountSupportVendor: [],
            isAddon: false,
            isSubscribed: false,
            hasMorePlans: false,
            sellingTypes: ['token'],
            freeTrialDays: 0,
            previousPackageType: 'consumable',
            isSelected: false,
          },
          {
            id: 543,
            name: 'PlanBundle1 (all subject) 10 session',
            subName: 'plan_bundle_1_10_session',
            description: 'test',
            longDescription: 'test',
            designatedQuestion: 20,
            planType: 'consumable',
            priority: 9999,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: -1,
            preDiscountPrice: 0,
            expiredAt: '2020-06-18 10:23:00 +0800',
            questionQuota: 10,
            isUnlimited: false,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 1200,
            contractPeriod: 0,
            isContract: false,
            paymentMethods: [
              {
                id: 1381,
                platform: 'web',
                sku:
                  'tw_web_starter_limited_1200monthly_p1000_q0_2020jun18_85303d',
                methodType: 'braintree',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 1000,
                isFocus: false,
                isActive: true,
                renewable: false,
                needsInvoice: true,
              },
            ],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: false,
            purchasable: true,
            discountSupportVendor: [],
            isAddon: false,
            isSubscribed: false,
            hasMorePlans: false,
            sellingTypes: ['token_subscription'],
            freeTrialDays: 0,
            previousPackageType: 'consumable',
            isSelected: false,
          },
          {
            id: 544,
            name: 'PlanBundle1 (all subject) 15 session',
            subName: 'plan_bundle_1_15_session',
            description: 'test',
            longDescription: 'test',
            designatedQuestion: 20,
            planType: 'consumable',
            priority: 9999,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: -1,
            preDiscountPrice: 0,
            expiredAt: '2020-06-18 10:26:00 +0800',
            questionQuota: 15,
            isUnlimited: false,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 1200,
            contractPeriod: 0,
            isContract: false,
            paymentMethods: [
              {
                id: 1384,
                platform: 'web',
                sku:
                  'tw_web_starter_limited_1200monthly_p1500_q0_2020jun18_347431',
                methodType: 'braintree',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 1500,
                isFocus: false,
                isActive: true,
                renewable: false,
                needsInvoice: true,
              },
            ],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: false,
            purchasable: true,
            discountSupportVendor: [],
            isAddon: false,
            isSubscribed: false,
            hasMorePlans: false,
            sellingTypes: ['token_subscription'],
            freeTrialDays: 0,
            previousPackageType: 'consumable',
            isSelected: false,
          },
        ],
      },
      {
        id: 5,
        title: 'Science available pack',
        description: 'lalala this is for science subjects',
        lowestPlanPrice: 300,
        plans: [
          {
            id: 545,
            name: 'PlanBundle2 (science) 3 session',
            subName: 'plan_bundle_2_3_session',
            description: 'test',
            longDescription: 'test',
            designatedQuestion: 20,
            planType: 'consumable',
            priority: 9999,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: -1,
            preDiscountPrice: 0,
            expiredAt: '2020-06-18 10:29:00 +0800',
            questionQuota: 3,
            isUnlimited: false,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 1200,
            contractPeriod: 0,
            isContract: false,
            paymentMethods: [
              {
                id: 1387,
                platform: 'web',
                sku:
                  'tw_web_starter_limited_1200monthly_p300_q0_2020jun18_bf0cf4',
                methodType: 'braintree',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 300,
                isFocus: false,
                isActive: true,
                renewable: false,
                needsInvoice: true,
              },
              {
                id: 2034,
                platform: 'web',
                sku:
                  'tw_web_starter_limited_1200monthly_p300_q3_2021may28_3b3713',
                methodType: 'neweb_mmk',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 300,
                isFocus: true,
                isActive: true,
                renewable: false,
                needsInvoice: true,
              },
              {
                id: 2035,
                platform: 'web',
                sku:
                  'tw_web_starter_limited_1200monthly_p300_q3_2021may28_816fe1',
                methodType: 'neweb_atm',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 300,
                isFocus: false,
                isActive: true,
                renewable: false,
                needsInvoice: true,
              },
              {
                id: 2036,
                platform: 'web',
                sku:
                  'tw_web_starter_limited_1200monthly_p300_q3_2021may28_28d164',
                methodType: 'neweb',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 300,
                isFocus: false,
                isActive: true,
                renewable: false,
                needsInvoice: true,
              },
            ],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: false,
            purchasable: true,
            discountSupportVendor: [],
            isAddon: false,
            isSubscribed: false,
            hasMorePlans: false,
            sellingTypes: ['token_subscription'],
            freeTrialDays: 0,
            previousPackageType: 'consumable',
            isSelected: false,
          },
          {
            id: 546,
            name: 'PlanBundle2 (science) 10 session',
            subName: 'plan_bundle_2_10_session',
            description: 'test',
            longDescription: 'test',
            designatedQuestion: 20,
            planType: 'consumable',
            priority: 9999,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: -1,
            preDiscountPrice: 0,
            expiredAt: '2020-06-18 12:33:00 +0800',
            questionQuota: 10,
            isUnlimited: false,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 1200,
            contractPeriod: 0,
            isContract: false,
            paymentMethods: [
              {
                id: 1390,
                platform: 'web',
                sku:
                  'tw_web_starter_limited_1200monthly_p1000_q0_2020jun18_73e06b',
                methodType: 'braintree',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 1000,
                isFocus: false,
                isActive: true,
                renewable: false,
                needsInvoice: true,
              },
            ],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: false,
            purchasable: true,
            discountSupportVendor: [],
            isAddon: false,
            isSubscribed: false,
            hasMorePlans: false,
            sellingTypes: ['token_subscription'],
            freeTrialDays: 0,
            previousPackageType: 'consumable',
            isSelected: false,
          },
          {
            id: 547,
            name: 'PlanBundle2 (science) 15 session',
            subName: 'plan_bundle_3_15_session',
            description: 'test',
            longDescription: 'test',
            designatedQuestion: 20,
            planType: 'consumable',
            priority: 9999,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: -1,
            preDiscountPrice: 0,
            expiredAt: '2020-06-18 12:39:00 +0800',
            questionQuota: 15,
            isUnlimited: false,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 1200,
            contractPeriod: 0,
            isContract: false,
            paymentMethods: [
              {
                id: 1393,
                platform: 'web',
                sku:
                  'tw_web_starter_limited_1200monthly_p1500_q0_2020jun18_9f13a1',
                methodType: 'braintree',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 1500,
                isFocus: false,
                isActive: true,
                renewable: false,
                needsInvoice: true,
              },
            ],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: false,
            purchasable: true,
            discountSupportVendor: [],
            isAddon: false,
            isSubscribed: false,
            hasMorePlans: false,
            sellingTypes: ['token_subscription'],
            freeTrialDays: 0,
            previousPackageType: 'consumable',
            isSelected: false,
          },
        ],
      },
      {
        id: 6,
        title: 'Society subjects available pack',
        description: 'lalala this is for society subjects',
        highlight: 'Most popular!',
        lowestPlanPrice: 299,
        plans: [
          {
            id: 548,
            name: 'PlanBundle3 (social science) 3 session',
            subName: 'plan_bundle_3_3_session',
            description: 'test',
            longDescription: 'test',
            designatedQuestion: 20,
            planType: 'consumable',
            priority: 9999,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: -1,
            preDiscountPrice: 0,
            expiredAt: '2020-06-18 15:18:00 +0800',
            questionQuota: 3,
            isUnlimited: false,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 1200,
            contractPeriod: 0,
            isContract: false,
            paymentMethods: [
              {
                id: 1396,
                platform: 'web',
                sku:
                  'tw_web_starter_limited_1200monthly_p300_q0_2020jun18_980505',
                methodType: 'braintree',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 299,
                isFocus: false,
                isActive: true,
                renewable: false,
                needsInvoice: true,
              },
              {
                id: 2037,
                platform: 'web',
                sku:
                  'tw_web_starter_limited_1200monthly_p300_q3_2021may28_a98cdc',
                methodType: 'neweb',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 300,
                isFocus: false,
                isActive: true,
                renewable: false,
                needsInvoice: true,
              },
            ],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: false,
            purchasable: true,
            discountSupportVendor: [],
            isAddon: false,
            isSubscribed: false,
            hasMorePlans: false,
            sellingTypes: ['token_subscription'],
            freeTrialDays: 0,
            previousPackageType: 'consumable',
            isSelected: false,
          },
          {
            id: 549,
            name: 'PlanBundle3 (social science) 10 session',
            subName: 'plan_bundle_3_10_session',
            description: 'test',
            longDescription: 'test',
            designatedQuestion: 20,
            planType: 'consumable',
            priority: 9999,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: -1,
            preDiscountPrice: 0,
            expiredAt: '2020-06-18 15:21:00 +0800',
            questionQuota: 10,
            isUnlimited: false,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 1200,
            contractPeriod: 0,
            isContract: false,
            paymentMethods: [
              {
                id: 1399,
                platform: 'web',
                sku:
                  'tw_web_starter_limited_1200monthly_p1000_q0_2020jun18_fd0744',
                methodType: 'braintree',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 999,
                isFocus: false,
                isActive: true,
                renewable: false,
                needsInvoice: true,
              },
            ],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: false,
            purchasable: true,
            discountSupportVendor: [],
            isAddon: false,
            isSubscribed: false,
            hasMorePlans: false,
            sellingTypes: ['token_subscription'],
            freeTrialDays: 0,
            previousPackageType: 'consumable',
            isSelected: false,
          },
          {
            id: 550,
            name: 'PlanBundle3 (social science) 15 session',
            subName: 'plan_bundle_3_15_session',
            description: 'test',
            longDescription: 'test',
            highlight: 'test',
            designatedQuestion: 20,
            planType: 'consumable',
            priority: 9999,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: -1,
            preDiscountPrice: 0,
            expiredAt: '2020-06-18 15:25:00 +0800',
            questionQuota: 15,
            isUnlimited: false,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 1200,
            contractPeriod: 0,
            isContract: false,
            paymentMethods: [
              {
                id: 1402,
                platform: 'web',
                sku:
                  'tw_web_starter_limited_1200monthly_p1500_q0_2020jun18_01c5cf',
                methodType: 'braintree',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 1499,
                isFocus: false,
                isActive: true,
                renewable: false,
                needsInvoice: true,
              },
            ],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: false,
            purchasable: true,
            discountSupportVendor: [],
            isAddon: false,
            isSubscribed: false,
            hasMorePlans: false,
            sellingTypes: ['token_subscription'],
            freeTrialDays: 0,
            previousPackageType: 'consumable',
            isSelected: false,
          },
        ],
      },
      {
        id: 13,
        title: 'Mini-classes on QA pack',
        description: 'Mini-classes on QA pack',
        lowestPlanPrice: 300,
        plans: [
          {
            id: 597,
            name: 'mini_class on QA x 3',
            subName: '(Sub-name) mini_class on QA',
            description: '(Description) mini_class on QA',
            longDescription: '(Long Description) mini_class on QA',
            designatedQuestion: 20,
            planType: 'consumable',
            priority: 1,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: -1,
            preDiscountPrice: 0,
            expiredAt: '2020-11-02 16:38:00 +0800',
            questionQuota: 3,
            isUnlimited: false,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 1,
            contractPeriod: 0,
            isContract: false,
            paymentMethods: [
              {
                id: 1628,
                platform: 'web',
                sku:
                  'tw_web_starter_limited_1200monthly_p300_q0_2020nov02_f2aeba',
                methodType: 'braintree',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 300,
                isFocus: false,
                isActive: true,
                renewable: false,
                needsInvoice: true,
              },
              {
                id: 1629,
                platform: 'web',
                sku:
                  'tw_web_starter_limited_1200monthly_p300_q0_2020nov02_3e2bb5',
                methodType: 'neweb',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 300,
                isFocus: false,
                isActive: true,
                renewable: false,
                needsInvoice: true,
              },
            ],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: false,
            purchasable: true,
            discountSupportVendor: [],
            isAddon: false,
            isSubscribed: false,
            hasMorePlans: false,
            sellingTypes: ['token_subscription'],
            freeTrialDays: 0,
            previousPackageType: 'consumable',
            isSelected: false,
          },
          {
            id: 598,
            name: 'mini_class on QA x 10',
            subName: '(Sub-name) mini_class on QA',
            description: '(Description) mini_class on QA',
            longDescription: '(Long Description) mini_class on QA',
            designatedQuestion: 20,
            planType: 'consumable',
            priority: 2,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: -1,
            preDiscountPrice: 0,
            expiredAt: '2020-11-02 16:38:00 +0800',
            questionQuota: 10,
            isUnlimited: false,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 1200,
            contractPeriod: 0,
            isContract: false,
            paymentMethods: [
              {
                id: 1635,
                platform: 'web',
                sku:
                  'tw_web_starter_limited_1200monthly_p1000_q10_2020nov02_f12027',
                methodType: 'braintree',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 1000,
                isFocus: false,
                isActive: true,
                renewable: false,
                needsInvoice: true,
              },
              {
                id: 1636,
                platform: 'web',
                sku:
                  'tw_web_starter_limited_1200monthly_p1000_q10_2020nov02_cb0a16',
                methodType: 'neweb',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 1000,
                isFocus: false,
                isActive: true,
                renewable: false,
                needsInvoice: true,
              },
            ],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: false,
            purchasable: true,
            discountSupportVendor: [],
            isAddon: false,
            isSubscribed: false,
            hasMorePlans: false,
            sellingTypes: ['token_subscription'],
            freeTrialDays: 0,
            previousPackageType: 'consumable',
            isSelected: false,
          },
          {
            id: 414,
            name: 'Subscription- 50 Q a month + Study Planet 1 month',
            subName: '(sub-name)Subscription- 50 Q a month',
            description:
              '(Description)Subscription- 50 Q a month + Study Planet 1 month',
            longDescription: '(Long Description)Subscription- 50 Q a month',
            designatedQuestion: 20,
            planType: 'renewable',
            priority: 1002,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: -1,
            preDiscountPrice: 0,
            expiredAt: '2020-08-22 11:40:00 +0800',
            questionQuota: 9999999,
            isUnlimited: true,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 1,
            contractPeriod: 0,
            isContract: false,
            paymentMethods: [
              {
                id: 1570,
                platform: 'web',
                sku: 'tw_web_starter_limited_monthly_p100_q4_2020sep16_4c23e5',
                methodType: 'braintree',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 2000,
                isFocus: false,
                isActive: true,
                renewable: true,
                introductoryPrice: 1900,
                needsInvoice: true,
              },
              {
                id: 1676,
                platform: 'web',
                sku:
                  'tw_web_starter_limited_monthly_p2000_q50_2020dec16_f0e95f',
                methodType: 'neweb',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 2000,
                isFocus: false,
                isActive: true,
                renewable: false,
                needsInvoice: true,
              },
            ],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: true,
            purchasable: false,
            discountSupportVendor: [],
            isAddon: true,
            isSubscribed: false,
            hasMorePlans: false,
            sellingTypes: ['token_subscription'],
            freeTrialDays: 0,
            previousPackageType: 'renewable_subscription',
            isSelected: false,
          },
        ],
      },
    ],
    tokens: [
      {
        id: 347,
        name: 'UAT Consumable181204',
        subName: '999666',
        description: 'Consumable181204',
        longDescription: 'Consumable181204***',
        highlight: '火龍果FOCUS',
        designatedQuestion: 20,
        planType: 'consumable',
        priority: 9983,
        currency: 'TWD',
        displayCurrency: 'NT$ ',
        isSpecialOffer: false,
        isFreeTrial: false,
        isTimeLimited: false,
        registerWithinDays: -1,
        preDiscountPrice: 0,
        expiredAt: '2018-12-04 11:51:00 +0800',
        questionQuota: 5,
        isUnlimited: false,
        billingCyclePerDays: 0,
        billingCyclePerMonths: 1200,
        contractPeriod: 0,
        isContract: false,
        paymentMethods: [
          {
            id: 660,
            platform: 'web',
            sku: 'tw_web_starter_limited_1200monthly_p120_q5_2018dec04_ac019a',
            methodType: 'neweb',
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            price: 120,
            isFocus: false,
            isActive: true,
            renewable: false,
            needsInvoice: true,
          },
          {
            id: 675,
            platform: 'web',
            sku: 'tw_web_starter_limited_1200monthly_p120_q5_2018dec04_93b121',
            methodType: 'braintree',
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            price: 120,
            isFocus: false,
            isActive: true,
            needsInvoice: true,
          },
        ],
        deliveryType: ['shipping', 'in_store_pickup'],
        isFocus: true,
        purchasable: true,
        discountSupportVendor: [],
        isAddon: false,
        isSubscribed: false,
        hasMorePlans: false,
        sellingTypes: ['token_subscription'],
        freeTrialDays: 0,
        previousPackageType: 'consumable',
        isSelected: false,
      },
      {
        id: 1026,
        name: 'Test - Plan_name_220523',
        subName: 'Test - Sub_name_220523',
        description: 'Test - Description_220523',
        longDescription: 'Test - Long Description_220523',
        highlight: 'Test - highlight_220523',
        designatedQuestion: 20,
        planType: 'consumable',
        priority: 12345,
        currency: 'TWD',
        displayCurrency: 'NT$ ',
        isSpecialOffer: false,
        isFreeTrial: false,
        isTimeLimited: false,
        registerWithinDays: -1,
        preDiscountPrice: 0,
        expiredAt: '2022-05-23 15:59:00 +0800',
        questionQuota: 10,
        isUnlimited: false,
        billingCyclePerDays: 0,
        billingCyclePerMonths: 1,
        contractPeriod: 1200,
        isContract: true,
        paymentMethods: [
          {
            id: 2971,
            platform: 'web',
            sku: 'tw_web_limited_monthly_p110_q10_2022may23_b7cc06',
            methodType: 'neweb',
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            price: 110,
            isFocus: false,
            isActive: true,
            renewable: false,
            needsInvoice: true,
          },
        ],
        deliveryType: ['shipping', 'in_store_pickup'],
        isFocus: true,
        purchasable: true,
        discountSupportVendor: [],
        isAddon: false,
        isSubscribed: false,
        hasMorePlans: false,
        sellingTypes: ['token_subscription'],
        freeTrialDays: 0,
        previousPackageType: 'consumable',
        isSelected: false,
      },
      {
        id: 851,
        name: 'UAT 80題包',
        subName: 'UAT 80題包',
        description: 'UAT 80題包，原價880， 特價前三個月330',
        longDescription: 'UAT 80題包，原價880， 特價前三個月330',
        designatedQuestion: 20,
        planType: 'consumable',
        priority: 30117,
        currency: 'TWD',
        displayCurrency: 'NT$ ',
        isSpecialOffer: false,
        isFreeTrial: false,
        isTimeLimited: false,
        registerWithinDays: -1,
        preDiscountPrice: 0,
        expiredAt: '2022-04-14 14:44:00 +0800',
        questionQuota: 80,
        isUnlimited: false,
        billingCyclePerDays: 0,
        billingCyclePerMonths: 1,
        contractPeriod: 0,
        isContract: false,
        paymentMethods: [
          {
            id: 2815,
            platform: 'web',
            sku: 'tw_web_limited_monthly_p880_q0_2022apr14_f9520d',
            methodType: 'braintree',
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            price: 880,
            isFocus: false,
            isActive: true,
            renewable: true,
            introductoryPrice: 330,
            needsInvoice: true,
          },
        ],
        deliveryType: ['shipping', 'in_store_pickup'],
        isFocus: false,
        purchasable: true,
        discountSupportVendor: [],
        isAddon: false,
        isSubscribed: false,
        hasMorePlans: false,
        sellingTypes: ['token_subscription'],
        freeTrialDays: 0,
        previousPackageType: 'consumable',
        isSelected: false,
      },
      {
        id: 850,
        name: 'Test_Ann_220414',
        subName: 'Test_Ann_220414',
        description: 'Test_Ann_220414',
        longDescription: 'Test_Ann_220414',
        designatedQuestion: 20,
        planType: 'consumable',
        priority: 0,
        currency: 'TWD',
        displayCurrency: 'NT$ ',
        isSpecialOffer: false,
        isFreeTrial: false,
        isTimeLimited: false,
        registerWithinDays: -1,
        preDiscountPrice: 0,
        expiredAt: '2022-04-14 09:37:00 +0800',
        questionQuota: 26,
        isUnlimited: false,
        billingCyclePerDays: 0,
        billingCyclePerMonths: 1,
        contractPeriod: 12,
        isContract: true,
        paymentMethods: [
          {
            id: 2811,
            platform: 'web',
            sku: 'tw_web_limited_monthly_p99_q0_2022apr14_2d428a',
            methodType: 'braintree',
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            price: 99,
            isFocus: false,
            isActive: true,
            renewable: false,
            needsInvoice: true,
          },
          {
            id: 2812,
            platform: 'web',
            sku: 'tw_web_limited_monthly_p99_q0_2022apr14_7de723',
            methodType: 'neweb',
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            price: 99,
            isFocus: false,
            isActive: true,
            renewable: false,
            needsInvoice: true,
          },
        ],
        deliveryType: ['shipping', 'in_store_pickup'],
        isFocus: false,
        purchasable: true,
        discountSupportVendor: [],
        isAddon: false,
        isSubscribed: false,
        hasMorePlans: false,
        sellingTypes: ['token_subscription'],
        freeTrialDays: 0,
        previousPackageType: 'consumable',
        isSelected: false,
      },
      {
        id: 597,
        name: 'mini_class on QA x 3',
        subName: '(Sub-name) mini_class on QA',
        description: '(Description) mini_class on QA',
        longDescription: '(Long Description) mini_class on QA',
        designatedQuestion: 20,
        planType: 'consumable',
        priority: 1,
        currency: 'TWD',
        displayCurrency: 'NT$ ',
        isSpecialOffer: false,
        isFreeTrial: false,
        isTimeLimited: false,
        registerWithinDays: -1,
        preDiscountPrice: 0,
        expiredAt: '2020-11-02 16:38:00 +0800',
        questionQuota: 3,
        isUnlimited: false,
        billingCyclePerDays: 0,
        billingCyclePerMonths: 1,
        contractPeriod: 0,
        isContract: false,
        paymentMethods: [
          {
            id: 1628,
            platform: 'web',
            sku: 'tw_web_starter_limited_1200monthly_p300_q0_2020nov02_f2aeba',
            methodType: 'braintree',
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            price: 300,
            isFocus: false,
            isActive: true,
            renewable: false,
            needsInvoice: true,
          },
          {
            id: 1629,
            platform: 'web',
            sku: 'tw_web_starter_limited_1200monthly_p300_q0_2020nov02_3e2bb5',
            methodType: 'neweb',
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            price: 300,
            isFocus: false,
            isActive: true,
            renewable: false,
            needsInvoice: true,
          },
        ],
        deliveryType: ['shipping', 'in_store_pickup'],
        isFocus: false,
        purchasable: true,
        discountSupportVendor: [],
        isAddon: false,
        isSubscribed: false,
        hasMorePlans: false,
        sellingTypes: ['token_subscription'],
        freeTrialDays: 0,
        previousPackageType: 'consumable',
        isSelected: false,
      },
      {
        id: 598,
        name: 'mini_class on QA x 10',
        subName: '(Sub-name) mini_class on QA',
        description: '(Description) mini_class on QA',
        longDescription: '(Long Description) mini_class on QA',
        designatedQuestion: 20,
        planType: 'consumable',
        priority: 2,
        currency: 'TWD',
        displayCurrency: 'NT$ ',
        isSpecialOffer: false,
        isFreeTrial: false,
        isTimeLimited: false,
        registerWithinDays: -1,
        preDiscountPrice: 0,
        expiredAt: '2020-11-02 16:38:00 +0800',
        questionQuota: 10,
        isUnlimited: false,
        billingCyclePerDays: 0,
        billingCyclePerMonths: 1200,
        contractPeriod: 0,
        isContract: false,
        paymentMethods: [
          {
            id: 1635,
            platform: 'web',
            sku:
              'tw_web_starter_limited_1200monthly_p1000_q10_2020nov02_f12027',
            methodType: 'braintree',
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            price: 1000,
            isFocus: false,
            isActive: true,
            renewable: false,
            needsInvoice: true,
          },
          {
            id: 1636,
            platform: 'web',
            sku:
              'tw_web_starter_limited_1200monthly_p1000_q10_2020nov02_cb0a16',
            methodType: 'neweb',
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            price: 1000,
            isFocus: false,
            isActive: true,
            renewable: false,
            needsInvoice: true,
          },
        ],
        deliveryType: ['shipping', 'in_store_pickup'],
        isFocus: false,
        purchasable: true,
        discountSupportVendor: [],
        isAddon: false,
        isSubscribed: false,
        hasMorePlans: false,
        sellingTypes: ['token_subscription'],
        freeTrialDays: 0,
        previousPackageType: 'consumable',
        isSelected: false,
      },
      {
        id: 161,
        name: '試聽 5 題方案',
        subName: '試聽 5 題方案',
        description: '立即入手 5 個問題額度，無使用期限，適合想試用看看的你！',
        designatedQuestion: 20,
        planType: 'consumable',
        priority: 9999,
        currency: 'TWD',
        displayCurrency: 'NT$ ',
        isSpecialOffer: false,
        isFreeTrial: false,
        isTimeLimited: false,
        registerWithinDays: -1,
        preDiscountPrice: 0,
        questionQuota: 5,
        isUnlimited: false,
        billingCyclePerDays: 0,
        billingCyclePerMonths: 1200,
        contractPeriod: 0,
        isContract: false,
        paymentMethods: [
          {
            id: 253,
            platform: 'web',
            sku: 'tw_braintree_starter_limited_1200monthly_p150_q5_2017may12',
            methodType: 'braintree',
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            price: 150,
            isFocus: false,
            isActive: true,
            renewable: false,
            needsInvoice: true,
          },
          {
            id: 254,
            platform: 'web',
            sku: 'tw_neweb_starter_limited_1200monthly_p150_q5_2017may12',
            methodType: 'neweb',
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            price: 150,
            isFocus: false,
            isActive: true,
            renewable: false,
            needsInvoice: true,
          },
        ],
        deliveryType: ['shipping', 'in_store_pickup'],
        isFocus: false,
        purchasable: true,
        discountSupportVendor: [],
        isAddon: false,
        isSubscribed: false,
        hasMorePlans: false,
        sellingTypes: ['token'],
        freeTrialDays: 0,
        previousPackageType: 'consumable',
        isSelected: false,
      },
      {
        id: 422,
        name: 'For expired test',
        subName: 'TEST ONLY',
        description: 'TEST',
        designatedQuestion: 20,
        planType: 'consumable',
        priority: 9999,
        currency: 'TWD',
        displayCurrency: 'NT$ ',
        isSpecialOffer: false,
        isFreeTrial: false,
        isTimeLimited: false,
        registerWithinDays: -1,
        preDiscountPrice: 0,
        expiredAt: '2020-03-26 11:11:00 +0800',
        questionQuota: 1,
        isUnlimited: false,
        billingCyclePerDays: 0,
        billingCyclePerMonths: 1200,
        contractPeriod: 0,
        isContract: false,
        paymentMethods: [
          {
            id: 1127,
            platform: 'web',
            sku: 'tw_web_starter_limited_1200monthly_p10_q0_2020mar26_2b73c1',
            methodType: 'braintree',
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            price: 10,
            isFocus: false,
            isActive: true,
            renewable: false,
            needsInvoice: true,
          },
        ],
        deliveryType: ['shipping', 'in_store_pickup'],
        isFocus: false,
        purchasable: true,
        discountSupportVendor: [],
        isAddon: false,
        isSubscribed: false,
        hasMorePlans: false,
        sellingTypes: ['token'],
        freeTrialDays: 0,
        previousPackageType: 'consumable',
        isSelected: false,
      },
      {
        id: 542,
        name: 'intro - PlanBundle1 (all subject) 3 session',
        subName: 'intro - plan_bundle_1_3_session',
        description: 'introductory price test',
        longDescription: 'test',
        designatedQuestion: 20,
        planType: 'consumable',
        priority: 9999,
        currency: 'TWD',
        displayCurrency: 'NT$ ',
        isSpecialOffer: false,
        isFreeTrial: false,
        isTimeLimited: false,
        registerWithinDays: -1,
        preDiscountPrice: 0,
        expiredAt: '2020-06-18 10:17:00 +0800',
        questionQuota: 3,
        isUnlimited: false,
        billingCyclePerDays: 0,
        billingCyclePerMonths: 1200,
        contractPeriod: 0,
        isContract: false,
        paymentMethods: [
          {
            id: 1378,
            platform: 'web',
            sku: 'tw_web_starter_limited_1200monthly_p300_q0_2020jun18_3d2609',
            methodType: 'braintree',
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            price: 300,
            isFocus: false,
            isActive: true,
            renewable: false,
            needsInvoice: true,
          },
          {
            id: 1522,
            platform: 'web',
            sku: 'tw_web_starter_limited_1200monthly_p299_q3_2020sep03_290522',
            methodType: 'neweb',
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            price: 299,
            isFocus: false,
            isActive: true,
            renewable: false,
            needsInvoice: true,
          },
        ],
        deliveryType: ['shipping', 'in_store_pickup'],
        isFocus: false,
        purchasable: true,
        discountSupportVendor: [],
        isAddon: false,
        isSubscribed: false,
        hasMorePlans: false,
        sellingTypes: ['token'],
        freeTrialDays: 0,
        previousPackageType: 'consumable',
        isSelected: false,
      },
    ],
    miniClasses: [
      {
        id: 392,
        name: 'UAT Time base 3',
        subName: 'UAT Time base 3',
        description: 'UAT Time base 3 description',
        longDescription: 'UAT Time base 3 description',
        designatedQuestion: 20,
        planType: 'consumable',
        priority: 9999,
        currency: 'TWD',
        displayCurrency: 'NT$ ',
        isSpecialOffer: false,
        isFreeTrial: false,
        isTimeLimited: false,
        registerWithinDays: -1,
        preDiscountPrice: 0,
        expiredAt: '2019-07-23 16:08:00 +0800',
        questionQuota: 3,
        isUnlimited: false,
        billingCyclePerDays: 0,
        billingCyclePerMonths: 1200,
        contractPeriod: 0,
        isContract: false,
        paymentMethods: [
          {
            id: 1026,
            platform: 'web',
            sku: 'tw_web_starter_limited_1200monthly_p90_q0_2019jul23_8a62c5',
            methodType: 'braintree',
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            price: 90,
            isFocus: false,
            isActive: true,
            renewable: false,
            needsInvoice: true,
          },
          {
            id: 1027,
            platform: 'web',
            sku: 'tw_web_starter_limited_1200monthly_p90_q0_2019jul23_1300d3',
            methodType: 'neweb',
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            price: 90,
            isFocus: false,
            isActive: true,
            renewable: false,
            needsInvoice: true,
          },
        ],
        deliveryType: ['shipping', 'in_store_pickup'],
        isFocus: false,
        purchasable: true,
        discountSupportVendor: [],
        isAddon: false,
        isSubscribed: false,
        hasMorePlans: false,
        sellingTypes: ['token_subscription'],
        freeTrialDays: 0,
        previousPackageType: 'consumable',
        isSelected: false,
      },
      {
        id: 588,
        name: '[iOS- braintree] Time-based Session 2',
        subName: 'iOS / braintree / no-free trial/ $10 discount',
        description: 'Time-based Session',
        longDescription: 'Time-based Session',
        designatedQuestion: 20,
        planType: 'consumable',
        priority: 9999,
        currency: 'TWD',
        displayCurrency: 'NT$ ',
        isSpecialOffer: false,
        isFreeTrial: false,
        isTimeLimited: false,
        registerWithinDays: -1,
        preDiscountPrice: 100,
        expiredAt: '2020-10-10 23:59:00 +0800',
        questionQuota: 1,
        isUnlimited: false,
        billingCyclePerDays: 0,
        billingCyclePerMonths: 1200,
        contractPeriod: 0,
        isContract: false,
        paymentMethods: [
          {
            id: 1582,
            platform: 'web',
            sku: 'tw_web_starter_limited_1200monthly_p100_q0_2020sep29_8fd419',
            methodType: 'braintree',
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            price: 90,
            isFocus: false,
            isActive: true,
            renewable: false,
            needsInvoice: true,
          },
          {
            id: 1588,
            platform: 'web',
            sku: 'tw_web_starter_limited_1200monthly_p100_q1_2020oct08_130d99',
            methodType: 'neweb',
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            price: 100,
            isFocus: false,
            isActive: true,
            renewable: false,
            needsInvoice: true,
          },
        ],
        deliveryType: ['shipping', 'in_store_pickup'],
        isFocus: false,
        purchasable: true,
        discountSupportVendor: [],
        isAddon: false,
        isSubscribed: false,
        hasMorePlans: false,
        sellingTypes: ['token_subscription'],
        freeTrialDays: 0,
        previousPackageType: 'consumable',
        isSelected: false,
      },
    ],
    webSubscriptionGroups: [
      {
        contractPeriod: 0,
        plans: [
          {
            id: 268,
            name: 'MOCK UAT 1 個月問到飽方案',
            subName: '每月問到飽',
            description: '每天超過三題時，單價最低的方案',
            longDescription:
              '每月無限題數全科放膽問！單日發問超過 3 題，就選此方案吧！',
            designatedQuestion: 20,
            planType: 'renewable',
            priority: 1099,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: -1,
            preDiscountPrice: 1800,
            expiredAt: '2021-03-31 17:24:00 +0800',
            questionQuota: 9999999,
            isUnlimited: true,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 1,
            contractPeriod: 0,
            isContract: false,
            paymentMethods: [
              {
                id: 432,
                platform: 'web',
                sku:
                  'tw_web_standard_unlimited_monthly_p2890_qunl_2018mar31_0e6ae5',
                methodType: 'braintree',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 1500,
                isFocus: false,
                isActive: true,
                renewable: true,
                needsInvoice: true,
              },
              {
                id: 433,
                platform: 'web',
                sku:
                  'tw_web_standard_unlimited_monthly_p2890_qunl_2018mar31_c6d589',
                methodType: 'neweb',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 20001,
                isFocus: false,
                isActive: true,
                renewable: false,
                needsInvoice: true,
              },
            ],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: true,
            purchasable: false,
            discountSupportVendor: ['lgu'],
            isAddon: false,
            isSubscribed: false,
            hasMorePlans: false,
            sellingTypes: ['token_subscription'],
            freeTrialDays: 0,
            previousPackageType: 'renewable_subscription',
            isSelected: false,
          },
          {
            id: 271,
            name: '(name) Subscription- unlimited Q 3 month',
            subName: '(sub-name)Subscription- unlimited Q 3 month',
            description: '(Description)Subscription- unlimited Q 3 month',
            longDescription:
              '(Long Description)Subscription- unlimited Q 3 month',
            highlight: '激推',
            designatedQuestion: 20,
            planType: 'renewable',
            priority: 1001,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: -1,
            preDiscountPrice: 0,
            expiredAt: '2021-07-31 23:59:00 +0800',
            questionQuota: 9999999,
            isUnlimited: true,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 3,
            contractPeriod: 0,
            isContract: false,
            paymentMethods: [
              {
                id: 450,
                platform: 'web',
                sku:
                  'tw_web_premium_unlimited_3monthly_p6590_qunl_2018mar31_ac60e8',
                methodType: 'braintree',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 3000,
                isFocus: false,
                isActive: true,
                renewable: true,
                introductoryPrice: 2400,
                needsInvoice: true,
              },
              {
                id: 451,
                platform: 'web',
                sku:
                  'tw_web_premium_unlimited_3monthly_p6590_qunl_2018mar31_cf4f77',
                methodType: 'neweb',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 3000,
                isFocus: false,
                isActive: true,
                renewable: false,
                needsInvoice: true,
              },
            ],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: true,
            purchasable: false,
            discountSupportVendor: ['lgu'],
            isAddon: true,
            isSubscribed: false,
            hasMorePlans: false,
            sellingTypes: ['token_subscription'],
            freeTrialDays: 0,
            previousPackageType: 'renewable_subscription',
            isSelected: false,
          },
          {
            id: 415,
            name: 'Subscription- 25 Q a month + Study Planet 1 month',
            subName: 'Subscription- 25 Q a month + Study Planet 1 month',
            description:
              '(Description)Subscription- 25 Q a month + Study Planet 1 month',
            longDescription:
              'Subscription- 25 Q a month + Study Planet 1 month',
            designatedQuestion: 20,
            planType: 'renewable',
            priority: 1003,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: -1,
            preDiscountPrice: 0,
            expiredAt: '2023-09-22 10:57:00 +0800',
            questionQuota: 25,
            isUnlimited: false,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 1,
            contractPeriod: 0,
            isContract: false,
            paymentMethods: [
              {
                id: 1571,
                platform: 'web',
                sku: 'tw_web_starter_limited_monthly_p1000_q8_2020sep16_c2af7a',
                methodType: 'braintree',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 1000,
                isFocus: false,
                isActive: true,
                renewable: true,
                needsInvoice: true,
              },
              {
                id: 1679,
                platform: 'web',
                sku:
                  'tw_web_starter_limited_monthly_p2000_q25_2020dec16_2fdd4a',
                methodType: 'neweb',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 2000,
                isFocus: false,
                isActive: true,
                renewable: false,
                needsInvoice: true,
              },
            ],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: true,
            purchasable: false,
            discountSupportVendor: [],
            isAddon: true,
            isSubscribed: false,
            hasMorePlans: true,
            sellingTypes: ['token_subscription'],
            freeTrialDays: 0,
            previousPackageType: 'renewable_subscription',
            isSelected: false,
          },
          {
            id: 414,
            name: 'Subscription- 50 Q a month + Study Planet 1 month',
            subName: '(sub-name)Subscription- 50 Q a month',
            description:
              '(Description)Subscription- 50 Q a month + Study Planet 1 month',
            longDescription: '(Long Description)Subscription- 50 Q a month',
            designatedQuestion: 20,
            planType: 'renewable',
            priority: 1002,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: -1,
            preDiscountPrice: 0,
            expiredAt: '2020-08-22 11:40:00 +0800',
            questionQuota: 9999999,
            isUnlimited: true,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 1,
            contractPeriod: 0,
            isContract: false,
            paymentMethods: [
              {
                id: 1570,
                platform: 'web',
                sku: 'tw_web_starter_limited_monthly_p100_q4_2020sep16_4c23e5',
                methodType: 'braintree',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 2000,
                isFocus: false,
                isActive: true,
                renewable: true,
                introductoryPrice: 1900,
                needsInvoice: true,
              },
              {
                id: 1676,
                platform: 'web',
                sku:
                  'tw_web_starter_limited_monthly_p2000_q50_2020dec16_f0e95f',
                methodType: 'neweb',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 2000,
                isFocus: false,
                isActive: true,
                renewable: false,
                needsInvoice: true,
              },
            ],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: true,
            purchasable: false,
            discountSupportVendor: [],
            isAddon: true,
            isSubscribed: false,
            hasMorePlans: false,
            sellingTypes: ['token_subscription'],
            freeTrialDays: 0,
            previousPackageType: 'renewable_subscription',
            isSelected: false,
          },
          {
            id: 615,
            name: 'name_zh-TW',
            subName: 'sub_name_zh-TW',
            description: 'description_zh-TW',
            longDescription: '首月半價後面恢復原價，這邊是寫來嚇嚇你的',
            designatedQuestion: 20,
            planType: 'renewable',
            priority: 1010,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: -1,
            preDiscountPrice: 0,
            expiredAt: '2021-01-08 20:16:00 +0800',
            questionQuota: 20,
            isUnlimited: false,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 1,
            contractPeriod: 0,
            isContract: false,
            paymentMethods: [
              {
                id: 1728,
                platform: 'web',
                sku: 'tw_web_starter_limited_monthly_p1000_q0_2021jan08_3af287',
                methodType: 'braintree',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 1000,
                isFocus: false,
                isActive: true,
                renewable: true,
                introductoryPrice: 500,
                needsInvoice: true,
              },
            ],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: false,
            purchasable: false,
            discountSupportVendor: ['lgu'],
            isAddon: false,
            isSubscribed: false,
            hasMorePlans: false,
            sellingTypes: ['token_subscription'],
            freeTrialDays: 0,
            previousPackageType: 'renewable_subscription',
            isSelected: false,
          },
          {
            id: 413,
            name: 'UAT  Time-based subscription ',
            subName: 'time-based sub',
            description: 'time-based subscription',
            longDescription: 'time-based subscriptionnnnnnnnnnnnn',
            designatedQuestion: 20,
            planType: 'renewable',
            priority: 1010,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: -1,
            preDiscountPrice: 0,
            expiredAt: '2019-12-09 14:33:00 +0800',
            questionQuota: 15,
            isUnlimited: false,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 1,
            contractPeriod: 0,
            isContract: false,
            paymentMethods: [
              {
                id: 1109,
                platform: 'web',
                sku:
                  'tw_web_starter_limited_monthly_p100000_q15_2019dec09_7a7901',
                methodType: 'braintree',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 10000,
                isFocus: false,
                isActive: true,
                renewable: false,
                needsInvoice: true,
              },
            ],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: false,
            purchasable: true,
            discountSupportVendor: [],
            isAddon: false,
            isSubscribed: false,
            hasMorePlans: false,
            sellingTypes: ['token'],
            freeTrialDays: 0,
            previousPackageType: 'renewable_subscription',
            isSelected: false,
          },
          {
            id: 607,
            name: 'Subscription- 5 Q a month for writing session',
            subName: '(sub-name) Subscription- 5 Q a month for writing session',
            description:
              '(Description) Subscription- 5 Q a month for writing session',
            longDescription:
              '(Long Description) Subscription- 5 Q a month for writing session',
            designatedQuestion: 5,
            planType: 'renewable',
            priority: 1010,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: -1,
            preDiscountPrice: 0,
            expiredAt: '2020-12-16 09:37:00 +0800',
            questionQuota: 5,
            isUnlimited: false,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 1,
            contractPeriod: 0,
            isContract: false,
            paymentMethods: [
              {
                id: 1672,
                platform: 'web',
                sku: 'tw_web_starter_limited_monthly_p1000_q5_2020dec16_34533f',
                methodType: 'braintree',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 1000,
                isFocus: false,
                isActive: true,
                renewable: false,
                needsInvoice: true,
              },
              {
                id: 1674,
                platform: 'web',
                sku: 'tw_web_starter_limited_monthly_p1000_q5_2020dec16_70daef',
                methodType: 'neweb',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 1000,
                isFocus: false,
                isActive: true,
                renewable: false,
                needsInvoice: true,
              },
            ],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: false,
            purchasable: true,
            discountSupportVendor: [],
            isAddon: false,
            isSubscribed: false,
            hasMorePlans: false,
            sellingTypes: ['token'],
            freeTrialDays: 0,
            previousPackageType: 'renewable_subscription',
            isSelected: false,
          },
          {
            id: 614,
            name: '(name)每月10題，歡迎嘗試升級方案',
            subName: '(sub)每月10題，歡迎嘗試升級方案',
            description: '(description)歡迎嘗試升級方案',
            longDescription: '(long description)每月10題，歡迎嘗試升級方案',
            designatedQuestion: 20,
            planType: 'renewable',
            priority: 1010,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: -1,
            preDiscountPrice: 0,
            expiredAt: '2021-01-08 20:08:00 +0800',
            questionQuota: 10,
            isUnlimited: false,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 1,
            contractPeriod: 0,
            isContract: false,
            paymentMethods: [
              {
                id: 1725,
                platform: 'web',
                sku: 'tw_web_starter_limited_monthly_p500_q0_2021jan08_c8c568',
                methodType: 'braintree',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 500,
                isFocus: false,
                isActive: true,
                renewable: true,
                needsInvoice: true,
              },
            ],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: false,
            purchasable: false,
            discountSupportVendor: [],
            isAddon: false,
            isSubscribed: false,
            hasMorePlans: false,
            sellingTypes: ['token_subscription'],
            freeTrialDays: 0,
            previousPackageType: 'renewable_subscription',
            isSelected: false,
          },
          {
            id: 616,
            name: '(name)每月30題，歡迎嘗試降級方案',
            subName: '每月30題，歡迎嘗試降級方案',
            description: '歡迎嘗試降級方案',
            longDescription: '(long description)每月30題，歡迎嘗試降級方案',
            designatedQuestion: 20,
            planType: 'renewable',
            priority: 1010,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: -1,
            preDiscountPrice: 0,
            expiredAt: '2021-01-08 20:22:00 +0800',
            questionQuota: 30,
            isUnlimited: false,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 1,
            contractPeriod: 0,
            isContract: false,
            paymentMethods: [
              {
                id: 1731,
                platform: 'web',
                sku: 'tw_web_starter_limited_monthly_p1500_q0_2021jan08_98cacd',
                methodType: 'braintree',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 1500,
                isFocus: false,
                isActive: true,
                renewable: true,
                needsInvoice: true,
              },
            ],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: false,
            purchasable: false,
            discountSupportVendor: [],
            isAddon: false,
            isSubscribed: false,
            hasMorePlans: false,
            sellingTypes: ['token_subscription'],
            freeTrialDays: 0,
            previousPackageType: 'renewable_subscription',
            isSelected: false,
          },
          {
            id: 660,
            name: 'Arthur test 1 billing and no contract',
            subName: 'Arthur test 1 billing and no contract',
            description: 'Arthur test 1 billing and no contract',
            longDescription: 'Arthur test 1 billing and no contract',
            designatedQuestion: 20,
            planType: 'renewable',
            priority: 1010,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: -1,
            preDiscountPrice: 0,
            expiredAt: '2021-04-20 14:34:00 +0800',
            questionQuota: 50,
            isUnlimited: false,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 1,
            contractPeriod: 0,
            isContract: false,
            paymentMethods: [
              {
                id: 1999,
                platform: 'web',
                sku: 'tw_web_starter_limited_monthly_p4000_q0_2021apr20_c95c92',
                methodType: 'braintree',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 4000,
                isFocus: false,
                isActive: true,
                renewable: true,
                needsInvoice: true,
              },
            ],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: false,
            purchasable: false,
            discountSupportVendor: [],
            isAddon: false,
            isSubscribed: true,
            hasMorePlans: false,
            sellingTypes: ['token_subscription'],
            freeTrialDays: 0,
            previousPackageType: 'renewable_subscription',
            isSelected: false,
          },
          {
            id: 664,
            name: 'Subscription- 20Q for senior high only',
            subName: '(Sub-name)Subscription- 20Q for senior high only',
            description: '(Description)Subscription- 20Q for senior high only',
            longDescription:
              '(Long Description)Subscription- 20Q for senior high only',
            designatedQuestion: 20,
            planType: 'renewable',
            priority: 1010,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: -1,
            preDiscountPrice: 0,
            expiredAt: '2021-05-06 09:31:00 +0800',
            questionQuota: 20,
            isUnlimited: false,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 1,
            contractPeriod: 0,
            isContract: false,
            paymentMethods: [
              {
                id: 2006,
                platform: 'web',
                sku: 'tw_web_starter_limited_monthly_p1500_q0_2021may06_bdf206',
                methodType: 'braintree',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 1500,
                isFocus: false,
                isActive: true,
                renewable: true,
                needsInvoice: true,
              },
            ],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: false,
            purchasable: true,
            discountSupportVendor: [],
            isAddon: false,
            isSubscribed: true,
            hasMorePlans: false,
            sellingTypes: ['token_subscription'],
            freeTrialDays: 0,
            previousPackageType: 'renewable_subscription',
            isSelected: false,
          },
          {
            id: 665,
            name: 'Subscription- 20Q for junior high only',
            subName: '(Sub-name)Subscription- 20Q for junior high only',
            description:
              '(Description)Subscription- 20Q for junior high only\r\n',
            longDescription:
              '(Long Description)Subscription- 20Q for junior high only',
            designatedQuestion: 20,
            planType: 'renewable',
            priority: 1010,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: -1,
            preDiscountPrice: 0,
            expiredAt: '2021-05-06 09:35:00 +0800',
            questionQuota: 20,
            isUnlimited: false,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 1,
            contractPeriod: 0,
            isContract: false,
            paymentMethods: [
              {
                id: 2009,
                platform: 'web',
                sku: 'tw_web_starter_limited_monthly_p1000_q0_2021may06_7cb5dc',
                methodType: 'braintree',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 1000,
                isFocus: false,
                isActive: true,
                renewable: true,
                needsInvoice: true,
              },
            ],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: false,
            purchasable: true,
            discountSupportVendor: [],
            isAddon: false,
            isSubscribed: false,
            hasMorePlans: false,
            sellingTypes: ['token_subscription'],
            freeTrialDays: 0,
            previousPackageType: 'renewable_subscription',
            isSelected: false,
          },
          {
            id: 382,
            name: 'UAT Arthur test no quota',
            subName: 'UAT Arthur test no quota sub',
            description: 'UAT Arthur test no quota description',
            longDescription: 'UAT Arthur test no quota long description',
            designatedQuestion: 20,
            planType: 'renewable',
            priority: 7000,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: -1,
            preDiscountPrice: 400,
            expiredAt: '2019-05-22 16:55:00 +0800',
            questionQuota: 0,
            isUnlimited: false,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 1,
            contractPeriod: 0,
            isContract: false,
            paymentMethods: [
              {
                id: 1002,
                platform: 'web',
                sku: 'tw_web_starter_limited_monthly_p300_q0_2019may22_4249e0',
                methodType: 'braintree',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 300,
                isFocus: false,
                isActive: true,
                renewable: true,
                needsInvoice: true,
              },
            ],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: false,
            purchasable: true,
            discountSupportVendor: ['lgu'],
            isAddon: false,
            isSubscribed: true,
            hasMorePlans: false,
            sellingTypes: ['token_subscription'],
            freeTrialDays: 0,
            previousPackageType: 'renewable_subscription',
            isSelected: false,
          },
        ],
      },
      {
        contractPeriod: 12,
        plans: [
          {
            id: 601,
            name: 'annual plan test',
            subName: 'sub title',
            description: 'this is Description of a test for annual plan',
            longDescription:
              'this is Long Description of a test for annual plan',
            highlight: 'annual!',
            designatedQuestion: 20,
            planType: 'renewable',
            priority: 2120,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: -1,
            preDiscountPrice: 0,
            expiredAt: '2023-12-30 18:17:00 +0800',
            questionQuota: 50,
            isUnlimited: false,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 1,
            contractPeriod: 12,
            isContract: true,
            paymentMethods: [
              {
                id: 1650,
                platform: 'web',
                sku:
                  'tw_web_standard_limited_12monthly_p10000_q0_2020nov30_a3c1aa',
                methodType: 'braintree',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 10000,
                isFocus: false,
                isActive: true,
                renewable: true,
                needsInvoice: true,
              },
              {
                id: 2056,
                platform: 'web',
                sku:
                  'tw_web_starter_limited_monthly_p20001_q50_2021jun16_89ff1e',
                methodType: 'neweb',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 20000,
                isFocus: false,
                isActive: true,
                renewable: false,
                needsInvoice: true,
              },
            ],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: true,
            purchasable: false,
            discountSupportVendor: [],
            isAddon: false,
            isSubscribed: false,
            hasMorePlans: false,
            sellingTypes: ['token_subscription'],
            freeTrialDays: 0,
            previousPackageType: 'renewable_subscription',
            isSelected: false,
          },
          {
            id: 619,
            name: '(name)港式年繳方案，每月 30 題',
            subName: 'HK annual plan style',
            description: 'HK annual plan style in Description',
            longDescription:
              '(long description) HK annual plan style in Long Description',
            designatedQuestion: 20,
            planType: 'renewable',
            priority: 1010,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: -1,
            preDiscountPrice: 0,
            expiredAt: '2021-01-15 00:49:00 +0800',
            questionQuota: 30,
            isUnlimited: false,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 1,
            contractPeriod: 12,
            isContract: true,
            paymentMethods: [
              {
                id: 1742,
                platform: 'web',
                sku: 'tw_web_starter_limited_monthly_p1200_q0_2021jan15_3b195f',
                methodType: 'braintree',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 1200,
                isFocus: false,
                isActive: true,
                renewable: true,
                needsInvoice: true,
              },
            ],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: true,
            purchasable: false,
            discountSupportVendor: [],
            isAddon: false,
            isSubscribed: false,
            hasMorePlans: false,
            sellingTypes: ['token_subscription'],
            freeTrialDays: 0,
            previousPackageType: 'renewable_subscription',
            isSelected: false,
          },
          {
            id: 809,
            name: 'Test_ann_plan_0314_part2',
            subName: 'Test_ann_plan_0314_part2',
            description: 'Test_ann_plan_0314_part2',
            longDescription: 'Test_ann_plan_0314_part2',
            highlight: 'Test_ann_plan_0314_part2',
            designatedQuestion: 20,
            planType: 'renewable',
            priority: 100,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: -1,
            preDiscountPrice: 0,
            expiredAt: '2022-03-14 17:03:00 +0800',
            questionQuota: 325,
            isUnlimited: false,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 12,
            contractPeriod: 12,
            isContract: true,
            paymentMethods: [
              {
                id: 2661,
                platform: 'web',
                sku: 'tw_web_limited_12monthly_p555_q0_2022mar14_14ba65',
                methodType: 'braintree',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 555,
                isFocus: false,
                isActive: true,
                renewable: true,
                needsInvoice: true,
              },
            ],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: false,
            purchasable: true,
            discountSupportVendor: [],
            isAddon: false,
            isSubscribed: false,
            hasMorePlans: false,
            sellingTypes: ['token_subscription'],
            freeTrialDays: 0,
            previousPackageType: 'renewable_subscription',
            isSelected: false,
          },
          {
            id: 613,
            name: 'Neweb Only 10 sessions',
            subName: 'Neweb Only 10 sessions',
            description: 'Neweb Only 10 sessions',
            longDescription: 'Neweb Only 10 sessions',
            highlight: 'Neweb Only 10 sessions',
            designatedQuestion: 20,
            planType: 'renewable',
            priority: 1010,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: -1,
            preDiscountPrice: 0,
            expiredAt: '2021-01-06 09:28:00 +0800',
            questionQuota: 10,
            isUnlimited: false,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 1,
            contractPeriod: 12,
            isContract: true,
            paymentMethods: [
              {
                id: 1720,
                platform: 'web',
                sku: 'tw_web_starter_limited_monthly_p500_q0_2021jan06_21813f',
                methodType: 'neweb',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 500,
                isFocus: false,
                isActive: true,
                renewable: false,
                needsInvoice: true,
              },
            ],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: false,
            purchasable: false,
            discountSupportVendor: [],
            isAddon: false,
            isSubscribed: false,
            hasMorePlans: false,
            sellingTypes: ['token_subscription'],
            freeTrialDays: 0,
            previousPackageType: 'renewable_subscription',
            isSelected: false,
          },
          {
            id: 661,
            name: 'Arthur test 1 billing and 12 contract',
            subName: 'Arthur test 1 billing and 12 contract',
            description: 'Arthur test 1 billing and 12 contract',
            longDescription: 'Arthur test 1 billing and 12 contract',
            designatedQuestion: 20,
            planType: 'renewable',
            priority: 1010,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: -1,
            preDiscountPrice: 0,
            expiredAt: '2026-04-20 14:39:00 +0800',
            questionQuota: 50,
            isUnlimited: false,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 1,
            contractPeriod: 12,
            isContract: true,
            paymentMethods: [
              {
                id: 2000,
                platform: 'web',
                sku: 'tw_web_starter_limited_monthly_p4000_q0_2021apr20_094661',
                methodType: 'braintree',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 4000,
                isFocus: false,
                isActive: true,
                renewable: true,
                needsInvoice: true,
              },
            ],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: false,
            purchasable: false,
            discountSupportVendor: [],
            isAddon: false,
            isSubscribed: false,
            hasMorePlans: false,
            sellingTypes: ['token_subscription'],
            freeTrialDays: 0,
            previousPackageType: 'renewable_subscription',
            isSelected: false,
          },
          {
            id: 666,
            name:
              'Subscription- 20Q for senior high only (Annual Plan- HK way)',
            subName:
              '(Sub-name)Subscription- 20Q for senior high only (Annual Plan- HK way))',
            description:
              '(Description)Subscription- 20Q for senior high only (Annual Plan- HK way))',
            longDescription:
              '(Long Description)Subscription- 20Q for senior high only (Annual Plan- HK way))',
            designatedQuestion: 20,
            planType: 'renewable',
            priority: 1010,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: -1,
            preDiscountPrice: 0,
            expiredAt: '2021-05-06 09:38:00 +0800',
            questionQuota: 0,
            isUnlimited: false,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 1,
            contractPeriod: 12,
            isContract: true,
            paymentMethods: [
              {
                id: 2012,
                platform: 'web',
                sku: 'tw_web_starter_limited_monthly_p1250_q0_2021may06_83800e',
                methodType: 'braintree',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 1250,
                isFocus: false,
                isActive: true,
                renewable: true,
                needsInvoice: true,
              },
            ],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: false,
            purchasable: true,
            discountSupportVendor: [],
            isAddon: false,
            isSubscribed: false,
            hasMorePlans: false,
            sellingTypes: ['token_subscription'],
            freeTrialDays: 0,
            previousPackageType: 'renewable_subscription',
            isSelected: false,
          },
          {
            id: 656,
            name: '(name)港式年繳方案，每 2 月 30 題',
            subName: '(sub) 港式年繳方案，每 2 月 30 題',
            description: '(Description) 港式年繳方案，每 2 月 30 題',
            longDescription: '(Long Description) 港式年繳方案，每 2 月 30 題',
            designatedQuestion: 20,
            planType: 'renewable',
            priority: 1020,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: -1,
            preDiscountPrice: 0,
            expiredAt: '2021-04-07 21:55:00 +0800',
            questionQuota: 30,
            isUnlimited: false,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 2,
            contractPeriod: 12,
            isContract: true,
            paymentMethods: [
              {
                id: 1977,
                platform: 'web',
                sku:
                  'tw_web_starter_limited_2monthly_p2000_q0_2021apr07_ff04b1',
                methodType: 'braintree',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 2000,
                isFocus: false,
                isActive: true,
                renewable: true,
                needsInvoice: true,
              },
            ],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: false,
            purchasable: false,
            discountSupportVendor: [],
            isAddon: false,
            isSubscribed: false,
            hasMorePlans: false,
            sellingTypes: ['token_subscription'],
            freeTrialDays: 0,
            previousPackageType: 'renewable_subscription',
            isSelected: false,
          },
          {
            id: 620,
            name: '(name)正宗台式年繳方案，每月50題，總共600題',
            subName: 'TW style annual plan',
            description: 'TW style annual plan in Description',
            longDescription:
              '(long description) TW style annual plan in Long Description',
            designatedQuestion: 20,
            planType: 'non_renewable',
            priority: 9999,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: -1,
            preDiscountPrice: 0,
            expiredAt: '2021-01-15 01:05:00 +0800',
            questionQuota: 600,
            isUnlimited: false,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 12,
            contractPeriod: 12,
            isContract: true,
            paymentMethods: [
              {
                id: 1750,
                platform: 'web',
                sku:
                  'tw_web_starter_limited_monthly_p15000_q600_2021jan15_c063a4',
                methodType: 'braintree',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 15000,
                isFocus: false,
                isActive: true,
                renewable: false,
                needsInvoice: true,
              },
              {
                id: 2977,
                platform: 'web',
                sku: 'tw_web_limited_12monthly_p15000_q600_2022may25_3c33b3',
                methodType: 'neweb',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 15000,
                isFocus: false,
                isActive: true,
                renewable: false,
                needsInvoice: true,
              },
            ],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: false,
            purchasable: true,
            discountSupportVendor: [],
            isAddon: false,
            isSubscribed: false,
            hasMorePlans: false,
            sellingTypes: ['token_subscription'],
            freeTrialDays: 0,
            previousPackageType: 'non-renewable_subscription',
            isSelected: false,
          },
        ],
      },
      {
        contractPeriod: 3,
        plans: [
          {
            id: 655,
            name: '(name)韓式季繳方案，每月 30 題',
            subName: 'KR seasonal plan style',
            description: 'KR seasonal plan style in Description',
            longDescription:
              '(long description) KR seasonal plan style in Long Description',
            designatedQuestion: 20,
            planType: 'renewable',
            priority: 1010,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: -1,
            preDiscountPrice: 0,
            expiredAt: '2021-03-23 23:50:00 +0800',
            questionQuota: 30,
            isUnlimited: false,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 1,
            contractPeriod: 3,
            isContract: true,
            paymentMethods: [
              {
                id: 1952,
                platform: 'web',
                sku: 'tw_web_starter_limited_monthly_p1500_q0_2021mar23_7f548b',
                methodType: 'braintree',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 1500,
                isFocus: false,
                isActive: true,
                renewable: true,
                needsInvoice: true,
              },
            ],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: false,
            purchasable: false,
            discountSupportVendor: [],
            isAddon: false,
            isSubscribed: false,
            hasMorePlans: false,
            sellingTypes: ['token_subscription'],
            freeTrialDays: 0,
            previousPackageType: 'renewable_subscription',
            isSelected: false,
          },
        ],
      },
      {
        contractPeriod: 6,
        plans: [
          {
            id: 1024,
            name: '半年繳 QA 題數 non-renewable 合約方案',
            subName: '(sub-name) 每月 60 題，一口氣 360 題，一次付款',
            description: '(description) 每月 60 題，一口氣 360 題，一次付款',
            longDescription:
              '(long description) 每月 60 題，一口氣 360 題，一次付款',
            designatedQuestion: 20,
            planType: 'non_renewable',
            priority: 9999,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: -1,
            preDiscountPrice: 0,
            expiredAt: '2022-05-20 00:18:00 +0800',
            questionQuota: 360,
            isUnlimited: false,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 6,
            contractPeriod: 6,
            isContract: true,
            paymentMethods: [
              {
                id: 2966,
                platform: 'web',
                sku: 'tw_web_limited_6monthly_p8000_q0_2022may20_4da4e0',
                methodType: 'braintree',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 8000,
                isFocus: false,
                isActive: true,
                renewable: false,
                needsInvoice: true,
              },
            ],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: false,
            purchasable: false,
            discountSupportVendor: [],
            isAddon: false,
            isSubscribed: false,
            hasMorePlans: false,
            sellingTypes: ['token_subscription'],
            freeTrialDays: 0,
            previousPackageType: 'non-renewable_subscription',
            isSelected: false,
          },
        ],
      },
    ],
    subscriptionGroups: [
      {
        id: 6,
        designatedQuestion: 20,
        questionQuota: 10,
        isPopular: false,
        plans: [
          {
            id: 1026,
            name: 'Test - Plan_name_220523',
            subName: 'Test - Sub_name_220523',
            description: 'Test - Description_220523',
            longDescription: 'Test - Long Description_220523',
            highlight: 'Test - highlight_220523',
            designatedQuestion: 20,
            planType: 'consumable',
            priority: 12345,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: -1,
            preDiscountPrice: 0,
            expiredAt: '2022-05-23 15:59:00 +0800',
            questionQuota: 10,
            isUnlimited: false,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 1,
            contractPeriod: 1200,
            isContract: true,
            paymentMethods: [
              {
                id: 2971,
                platform: 'web',
                sku: 'tw_web_limited_monthly_p110_q10_2022may23_b7cc06',
                methodType: 'neweb',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 110,
                isFocus: false,
                isActive: true,
                renewable: false,
                needsInvoice: true,
              },
            ],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: true,
            purchasable: true,
            discountSupportVendor: [],
            isAddon: false,
            isSubscribed: false,
            hasMorePlans: false,
            sellingTypes: ['token_subscription'],
            freeTrialDays: 0,
            previousPackageType: 'consumable',
            isSelected: false,
          },
          {
            id: 614,
            name: '(name)每月10題，歡迎嘗試升級方案',
            subName: '(sub)每月10題，歡迎嘗試升級方案',
            description: '(description)歡迎嘗試升級方案',
            longDescription: '(long description)每月10題，歡迎嘗試升級方案',
            designatedQuestion: 20,
            planType: 'renewable',
            priority: 1010,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: -1,
            preDiscountPrice: 0,
            expiredAt: '2021-01-08 20:08:00 +0800',
            questionQuota: 10,
            isUnlimited: false,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 1,
            contractPeriod: 0,
            isContract: false,
            paymentMethods: [
              {
                id: 1725,
                platform: 'web',
                sku: 'tw_web_starter_limited_monthly_p500_q0_2021jan08_c8c568',
                methodType: 'braintree',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 500,
                isFocus: false,
                isActive: true,
                renewable: true,
                needsInvoice: true,
              },
            ],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: false,
            purchasable: false,
            discountSupportVendor: [],
            isAddon: false,
            isSubscribed: false,
            hasMorePlans: false,
            sellingTypes: ['token_subscription'],
            freeTrialDays: 0,
            previousPackageType: 'renewable_subscription',
            isSelected: false,
          },
        ],
      },
      {
        id: 7,
        designatedQuestion: 20,
        questionQuota: 20,
        isPopular: false,
        plans: [
          {
            id: 819,
            name: 'Test Plan By NT_031602 Subscription',
            subName: 'TP By NT_031602',
            description: 'Short Description',
            longDescription: 'Long Description',
            designatedQuestion: 20,
            planType: 'renewable',
            priority: 0,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: -1,
            preDiscountPrice: 0,
            expiredAt: '2022-03-16 14:03:00 +0800',
            questionQuota: 0,
            isUnlimited: false,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 1,
            contractPeriod: 0,
            isContract: false,
            paymentMethods: [],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: false,
            purchasable: true,
            discountSupportVendor: [],
            isAddon: false,
            isSubscribed: false,
            hasMorePlans: false,
            sellingTypes: ['token_subscription'],
            freeTrialDays: 0,
            previousPackageType: 'renewable_subscription',
            isSelected: false,
          },
          {
            id: 615,
            name: 'name_zh-TW',
            subName: 'sub_name_zh-TW',
            description: 'description_zh-TW',
            longDescription: '首月半價後面恢復原價，這邊是寫來嚇嚇你的',
            designatedQuestion: 20,
            planType: 'renewable',
            priority: 1010,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: -1,
            preDiscountPrice: 0,
            expiredAt: '2021-01-08 20:16:00 +0800',
            questionQuota: 20,
            isUnlimited: false,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 1,
            contractPeriod: 0,
            isContract: false,
            paymentMethods: [
              {
                id: 1728,
                platform: 'web',
                sku: 'tw_web_starter_limited_monthly_p1000_q0_2021jan08_3af287',
                methodType: 'braintree',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 1000,
                isFocus: false,
                isActive: true,
                renewable: true,
                introductoryPrice: 500,
                needsInvoice: true,
              },
            ],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: false,
            purchasable: false,
            discountSupportVendor: ['lgu'],
            isAddon: false,
            isSubscribed: false,
            hasMorePlans: false,
            sellingTypes: ['token_subscription'],
            freeTrialDays: 0,
            previousPackageType: 'renewable_subscription',
            isSelected: false,
          },
          {
            id: 664,
            name: 'Subscription- 20Q for senior high only',
            subName: '(Sub-name)Subscription- 20Q for senior high only',
            description: '(Description)Subscription- 20Q for senior high only',
            longDescription:
              '(Long Description)Subscription- 20Q for senior high only',
            designatedQuestion: 20,
            planType: 'renewable',
            priority: 1010,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: -1,
            preDiscountPrice: 0,
            expiredAt: '2021-05-06 09:31:00 +0800',
            questionQuota: 20,
            isUnlimited: false,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 1,
            contractPeriod: 0,
            isContract: false,
            paymentMethods: [
              {
                id: 2006,
                platform: 'web',
                sku: 'tw_web_starter_limited_monthly_p1500_q0_2021may06_bdf206',
                methodType: 'braintree',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 1500,
                isFocus: false,
                isActive: true,
                renewable: true,
                needsInvoice: true,
              },
            ],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: false,
            purchasable: true,
            discountSupportVendor: [],
            isAddon: false,
            isSubscribed: true,
            hasMorePlans: false,
            sellingTypes: ['token_subscription'],
            freeTrialDays: 0,
            previousPackageType: 'renewable_subscription',
            isSelected: false,
          },
          {
            id: 665,
            name: 'Subscription- 20Q for junior high only',
            subName: '(Sub-name)Subscription- 20Q for junior high only',
            description:
              '(Description)Subscription- 20Q for junior high only\r\n',
            longDescription:
              '(Long Description)Subscription- 20Q for junior high only',
            designatedQuestion: 20,
            planType: 'renewable',
            priority: 1010,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: -1,
            preDiscountPrice: 0,
            expiredAt: '2021-05-06 09:35:00 +0800',
            questionQuota: 20,
            isUnlimited: false,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 1,
            contractPeriod: 0,
            isContract: false,
            paymentMethods: [
              {
                id: 2009,
                platform: 'web',
                sku: 'tw_web_starter_limited_monthly_p1000_q0_2021may06_7cb5dc',
                methodType: 'braintree',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 1000,
                isFocus: false,
                isActive: true,
                renewable: true,
                needsInvoice: true,
              },
            ],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: false,
            purchasable: true,
            discountSupportVendor: [],
            isAddon: false,
            isSubscribed: false,
            hasMorePlans: false,
            sellingTypes: ['token_subscription'],
            freeTrialDays: 0,
            previousPackageType: 'renewable_subscription',
            isSelected: false,
          },
          {
            id: 666,
            name:
              'Subscription- 20Q for senior high only (Annual Plan- HK way)',
            subName:
              '(Sub-name)Subscription- 20Q for senior high only (Annual Plan- HK way))',
            description:
              '(Description)Subscription- 20Q for senior high only (Annual Plan- HK way))',
            longDescription:
              '(Long Description)Subscription- 20Q for senior high only (Annual Plan- HK way))',
            designatedQuestion: 20,
            planType: 'renewable',
            priority: 1010,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: -1,
            preDiscountPrice: 0,
            expiredAt: '2021-05-06 09:38:00 +0800',
            questionQuota: 0,
            isUnlimited: false,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 1,
            contractPeriod: 12,
            isContract: true,
            paymentMethods: [
              {
                id: 2012,
                platform: 'web',
                sku: 'tw_web_starter_limited_monthly_p1250_q0_2021may06_83800e',
                methodType: 'braintree',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 1250,
                isFocus: false,
                isActive: true,
                renewable: true,
                needsInvoice: true,
              },
            ],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: false,
            purchasable: true,
            discountSupportVendor: [],
            isAddon: false,
            isSubscribed: false,
            hasMorePlans: false,
            sellingTypes: ['token_subscription'],
            freeTrialDays: 0,
            previousPackageType: 'renewable_subscription',
            isSelected: false,
          },
        ],
      },
      {
        id: 1,
        designatedQuestion: 25,
        questionQuota: 25,
        isPopular: true,
        plans: [
          {
            id: 415,
            name: 'Subscription- 25 Q a month + Study Planet 1 month',
            subName: 'Subscription- 25 Q a month + Study Planet 1 month',
            description:
              '(Description)Subscription- 25 Q a month + Study Planet 1 month',
            longDescription:
              'Subscription- 25 Q a month + Study Planet 1 month',
            designatedQuestion: 20,
            planType: 'renewable',
            priority: 1003,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: -1,
            preDiscountPrice: 0,
            expiredAt: '2023-09-22 10:57:00 +0800',
            questionQuota: 25,
            isUnlimited: false,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 1,
            contractPeriod: 0,
            isContract: false,
            paymentMethods: [
              {
                id: 1571,
                platform: 'web',
                sku: 'tw_web_starter_limited_monthly_p1000_q8_2020sep16_c2af7a',
                methodType: 'braintree',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 1000,
                isFocus: false,
                isActive: true,
                renewable: true,
                needsInvoice: true,
              },
              {
                id: 1679,
                platform: 'web',
                sku:
                  'tw_web_starter_limited_monthly_p2000_q25_2020dec16_2fdd4a',
                methodType: 'neweb',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 2000,
                isFocus: false,
                isActive: true,
                renewable: false,
                needsInvoice: true,
              },
            ],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: true,
            purchasable: false,
            discountSupportVendor: [],
            isAddon: true,
            isSubscribed: false,
            hasMorePlans: true,
            sellingTypes: ['token_subscription'],
            freeTrialDays: 0,
            previousPackageType: 'renewable_subscription',
            isSelected: false,
          },
          {
            id: 267,
            name: 'UAT 25 題學霸訂閱方案（年繳方案）',
            subName: 'UAT 25 題學霸訂閱方案（年繳方案）',
            description:
              '每月 25 題基礎訂閱方案，由此開始你的學習旅程。導師的詳細解說17秒內立即讓你茅塞頓開。',
            longDescription: 'UAT 25 題學霸訂閱方案（年繳方案）',
            highlight: '原價1,650元，折扣20%',
            designatedQuestion: 20,
            planType: 'renewable',
            priority: 1025,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: true,
            registerWithinDays: -1,
            preDiscountPrice: 3000,
            expiredAt: '2021-07-31 17:10:00 +0800',
            questionQuota: 25,
            isUnlimited: false,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 3,
            contractPeriod: 12,
            isContract: true,
            paymentMethods: [],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: true,
            purchasable: true,
            discountSupportVendor: [],
            isAddon: false,
            isSubscribed: false,
            hasMorePlans: false,
            sellingTypes: ['token_subscription'],
            freeTrialDays: 0,
            previousPackageType: 'renewable_subscription',
            isSelected: false,
          },
          {
            id: 809,
            name: 'Test_ann_plan_0314_part2',
            subName: 'Test_ann_plan_0314_part2',
            description: 'Test_ann_plan_0314_part2',
            longDescription: 'Test_ann_plan_0314_part2',
            highlight: 'Test_ann_plan_0314_part2',
            designatedQuestion: 20,
            planType: 'renewable',
            priority: 100,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: -1,
            preDiscountPrice: 0,
            expiredAt: '2022-03-14 17:03:00 +0800',
            questionQuota: 325,
            isUnlimited: false,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 12,
            contractPeriod: 12,
            isContract: true,
            paymentMethods: [
              {
                id: 2661,
                platform: 'web',
                sku: 'tw_web_limited_12monthly_p555_q0_2022mar14_14ba65',
                methodType: 'braintree',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 555,
                isFocus: false,
                isActive: true,
                renewable: true,
                needsInvoice: true,
              },
            ],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: false,
            purchasable: true,
            discountSupportVendor: [],
            isAddon: false,
            isSubscribed: false,
            hasMorePlans: false,
            sellingTypes: ['token_subscription'],
            freeTrialDays: 0,
            previousPackageType: 'renewable_subscription',
            isSelected: false,
          },
        ],
      },
      {
        id: 8,
        designatedQuestion: 20,
        questionQuota: 30,
        isPopular: false,
        plans: [
          {
            id: 619,
            name: '(name)港式年繳方案，每月 30 題',
            subName: 'HK annual plan style',
            description: 'HK annual plan style in Description',
            longDescription:
              '(long description) HK annual plan style in Long Description',
            designatedQuestion: 20,
            planType: 'renewable',
            priority: 1010,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: -1,
            preDiscountPrice: 0,
            expiredAt: '2021-01-15 00:49:00 +0800',
            questionQuota: 30,
            isUnlimited: false,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 1,
            contractPeriod: 12,
            isContract: true,
            paymentMethods: [
              {
                id: 1742,
                platform: 'web',
                sku: 'tw_web_starter_limited_monthly_p1200_q0_2021jan15_3b195f',
                methodType: 'braintree',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 1200,
                isFocus: false,
                isActive: true,
                renewable: true,
                needsInvoice: true,
              },
            ],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: true,
            purchasable: false,
            discountSupportVendor: [],
            isAddon: false,
            isSubscribed: false,
            hasMorePlans: false,
            sellingTypes: ['token_subscription'],
            freeTrialDays: 0,
            previousPackageType: 'renewable_subscription',
            isSelected: false,
          },
          {
            id: 616,
            name: '(name)每月30題，歡迎嘗試降級方案',
            subName: '每月30題，歡迎嘗試降級方案',
            description: '歡迎嘗試降級方案',
            longDescription: '(long description)每月30題，歡迎嘗試降級方案',
            designatedQuestion: 20,
            planType: 'renewable',
            priority: 1010,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: -1,
            preDiscountPrice: 0,
            expiredAt: '2021-01-08 20:22:00 +0800',
            questionQuota: 30,
            isUnlimited: false,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 1,
            contractPeriod: 0,
            isContract: false,
            paymentMethods: [
              {
                id: 1731,
                platform: 'web',
                sku: 'tw_web_starter_limited_monthly_p1500_q0_2021jan08_98cacd',
                methodType: 'braintree',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 1500,
                isFocus: false,
                isActive: true,
                renewable: true,
                needsInvoice: true,
              },
            ],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: false,
            purchasable: false,
            discountSupportVendor: [],
            isAddon: false,
            isSubscribed: false,
            hasMorePlans: false,
            sellingTypes: ['token_subscription'],
            freeTrialDays: 0,
            previousPackageType: 'renewable_subscription',
            isSelected: false,
          },
          {
            id: 655,
            name: '(name)韓式季繳方案，每月 30 題',
            subName: 'KR seasonal plan style',
            description: 'KR seasonal plan style in Description',
            longDescription:
              '(long description) KR seasonal plan style in Long Description',
            designatedQuestion: 20,
            planType: 'renewable',
            priority: 1010,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: -1,
            preDiscountPrice: 0,
            expiredAt: '2021-03-23 23:50:00 +0800',
            questionQuota: 30,
            isUnlimited: false,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 1,
            contractPeriod: 3,
            isContract: true,
            paymentMethods: [
              {
                id: 1952,
                platform: 'web',
                sku: 'tw_web_starter_limited_monthly_p1500_q0_2021mar23_7f548b',
                methodType: 'braintree',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 1500,
                isFocus: false,
                isActive: true,
                renewable: true,
                needsInvoice: true,
              },
            ],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: false,
            purchasable: false,
            discountSupportVendor: [],
            isAddon: false,
            isSubscribed: false,
            hasMorePlans: false,
            sellingTypes: ['token_subscription'],
            freeTrialDays: 0,
            previousPackageType: 'renewable_subscription',
            isSelected: false,
          },
          {
            id: 656,
            name: '(name)港式年繳方案，每 2 月 30 題',
            subName: '(sub) 港式年繳方案，每 2 月 30 題',
            description: '(Description) 港式年繳方案，每 2 月 30 題',
            longDescription: '(Long Description) 港式年繳方案，每 2 月 30 題',
            designatedQuestion: 20,
            planType: 'renewable',
            priority: 1020,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: -1,
            preDiscountPrice: 0,
            expiredAt: '2021-04-07 21:55:00 +0800',
            questionQuota: 30,
            isUnlimited: false,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 2,
            contractPeriod: 12,
            isContract: true,
            paymentMethods: [
              {
                id: 1977,
                platform: 'web',
                sku:
                  'tw_web_starter_limited_2monthly_p2000_q0_2021apr07_ff04b1',
                methodType: 'braintree',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 2000,
                isFocus: false,
                isActive: true,
                renewable: true,
                needsInvoice: true,
              },
            ],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: false,
            purchasable: false,
            discountSupportVendor: [],
            isAddon: false,
            isSubscribed: false,
            hasMorePlans: false,
            sellingTypes: ['token_subscription'],
            freeTrialDays: 0,
            previousPackageType: 'renewable_subscription',
            isSelected: false,
          },
          {
            id: 825,
            name: 'Test_ann_plan_0317_2',
            subName: 'Test_ann_plan_0317_2',
            description: 'Test_ann_plan_0317_2',
            longDescription: 'Test_ann_plan_0317_2',
            designatedQuestion: 20,
            planType: 'renewable',
            priority: 8000,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            limitedDate: '2022-05-22 18:00:51 +0800',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: 5,
            preDiscountPrice: 300,
            expiredAt: '2022-03-17 15:24:00 +0800',
            questionQuota: 0,
            isUnlimited: false,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 1,
            contractPeriod: 3,
            isContract: true,
            paymentMethods: [
              {
                id: 2724,
                platform: 'web',
                sku: 'tw_web_limited_monthly_p222_q30_2022mar17_7c348d',
                methodType: 'braintree',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 222,
                isFocus: false,
                isActive: true,
                renewable: true,
                needsInvoice: true,
              },
            ],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: false,
            purchasable: true,
            discountSupportVendor: [],
            isAddon: false,
            isSubscribed: false,
            hasMorePlans: false,
            sellingTypes: ['token_subscription'],
            freeTrialDays: 0,
            previousPackageType: 'renewable_subscription',
            isSelected: false,
          },
        ],
      },
      {
        id: 9,
        designatedQuestion: 20,
        questionQuota: 50,
        isPopular: false,
        plans: [
          {
            id: 414,
            name: 'Subscription- 50 Q a month + Study Planet 1 month',
            subName: '(sub-name)Subscription- 50 Q a month',
            description:
              '(Description)Subscription- 50 Q a month + Study Planet 1 month',
            longDescription: '(Long Description)Subscription- 50 Q a month',
            designatedQuestion: 20,
            planType: 'renewable',
            priority: 1002,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: -1,
            preDiscountPrice: 0,
            expiredAt: '2020-08-22 11:40:00 +0800',
            questionQuota: 9999999,
            isUnlimited: true,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 1,
            contractPeriod: 0,
            isContract: false,
            paymentMethods: [
              {
                id: 1570,
                platform: 'web',
                sku: 'tw_web_starter_limited_monthly_p100_q4_2020sep16_4c23e5',
                methodType: 'braintree',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 2000,
                isFocus: false,
                isActive: true,
                renewable: true,
                introductoryPrice: 1900,
                needsInvoice: true,
              },
              {
                id: 1676,
                platform: 'web',
                sku:
                  'tw_web_starter_limited_monthly_p2000_q50_2020dec16_f0e95f',
                methodType: 'neweb',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 2000,
                isFocus: false,
                isActive: true,
                renewable: false,
                needsInvoice: true,
              },
            ],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: true,
            purchasable: false,
            discountSupportVendor: [],
            isAddon: true,
            isSubscribed: false,
            hasMorePlans: false,
            sellingTypes: ['token_subscription'],
            freeTrialDays: 0,
            previousPackageType: 'renewable_subscription',
            isSelected: false,
          },
          {
            id: 824,
            name: 'Test_ann_plan_0317_1',
            subName: 'Test_ann_plan_0317_1',
            description: 'Test_ann_plan_0317_1',
            longDescription: 'Test_ann_plan_0317_1',
            highlight: 'Test_ann_plan_0317_1',
            designatedQuestion: 20,
            planType: 'consumable',
            priority: 7000,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            limitedDate: '2022-05-22 18:00:51 +0800',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: 5,
            preDiscountPrice: 0,
            expiredAt: '2022-03-17 14:05:00 +0800',
            questionQuota: 0,
            isUnlimited: false,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 1,
            contractPeriod: 1,
            isContract: false,
            paymentMethods: [
              {
                id: 2713,
                platform: 'web',
                sku: 'tw_web_limited_monthly_p333_q50_2022mar17_482dd6',
                methodType: 'braintree',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 333,
                isFocus: false,
                isActive: true,
                renewable: false,
                needsInvoice: true,
              },
              {
                id: 2715,
                platform: 'web',
                sku: 'tw_web_limited_monthly_p333_q50_2022mar17_f5833a',
                methodType: 'neweb',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 333,
                isFocus: false,
                isActive: true,
                renewable: false,
                needsInvoice: true,
              },
            ],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: false,
            purchasable: true,
            discountSupportVendor: [],
            isAddon: false,
            isSubscribed: false,
            hasMorePlans: false,
            sellingTypes: ['token_subscription'],
            freeTrialDays: 0,
            previousPackageType: 'consumable',
            isSelected: false,
          },
          {
            id: 620,
            name: '(name)正宗台式年繳方案，每月50題，總共600題',
            subName: 'TW style annual plan',
            description: 'TW style annual plan in Description',
            longDescription:
              '(long description) TW style annual plan in Long Description',
            designatedQuestion: 20,
            planType: 'non_renewable',
            priority: 9999,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: -1,
            preDiscountPrice: 0,
            expiredAt: '2021-01-15 01:05:00 +0800',
            questionQuota: 600,
            isUnlimited: false,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 12,
            contractPeriod: 12,
            isContract: true,
            paymentMethods: [
              {
                id: 1750,
                platform: 'web',
                sku:
                  'tw_web_starter_limited_monthly_p15000_q600_2021jan15_c063a4',
                methodType: 'braintree',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 15000,
                isFocus: false,
                isActive: true,
                renewable: false,
                needsInvoice: true,
              },
              {
                id: 2977,
                platform: 'web',
                sku: 'tw_web_limited_12monthly_p15000_q600_2022may25_3c33b3',
                methodType: 'neweb',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 15000,
                isFocus: false,
                isActive: true,
                renewable: false,
                needsInvoice: true,
              },
            ],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: false,
            purchasable: true,
            discountSupportVendor: [],
            isAddon: false,
            isSubscribed: false,
            hasMorePlans: false,
            sellingTypes: ['token_subscription'],
            freeTrialDays: 0,
            previousPackageType: 'non-renewable_subscription',
            isSelected: false,
          },
        ],
      },
      {
        id: 17,
        designatedQuestion: 20,
        questionQuota: 60,
        isPopular: false,
        plans: [
          {
            id: 821,
            name: 'Test Plan 0316_04 1000&50&Sub',
            subName: 'TP By NT_0316_04',
            description: 'Test Plan 0316_04 1000&50&Sub',
            longDescription: 'Test Plan 0316_04 1000&50&Sub',
            designatedQuestion: 20,
            planType: 'renewable',
            priority: 0,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: -1,
            preDiscountPrice: 0,
            expiredAt: '2022-03-16 16:58:00 +0800',
            questionQuota: 0,
            isUnlimited: false,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 1,
            contractPeriod: 0,
            isContract: false,
            paymentMethods: [],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: false,
            purchasable: true,
            discountSupportVendor: [],
            isAddon: false,
            isSubscribed: false,
            hasMorePlans: false,
            sellingTypes: ['token_subscription'],
            freeTrialDays: 0,
            previousPackageType: 'renewable_subscription',
            isSelected: false,
          },
          {
            id: 1024,
            name: '半年繳 QA 題數 non-renewable 合約方案',
            subName: '(sub-name) 每月 60 題，一口氣 360 題，一次付款',
            description: '(description) 每月 60 題，一口氣 360 題，一次付款',
            longDescription:
              '(long description) 每月 60 題，一口氣 360 題，一次付款',
            designatedQuestion: 20,
            planType: 'non_renewable',
            priority: 9999,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: -1,
            preDiscountPrice: 0,
            expiredAt: '2022-05-20 00:18:00 +0800',
            questionQuota: 360,
            isUnlimited: false,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 6,
            contractPeriod: 6,
            isContract: true,
            paymentMethods: [
              {
                id: 2966,
                platform: 'web',
                sku: 'tw_web_limited_6monthly_p8000_q0_2022may20_4da4e0',
                methodType: 'braintree',
                currency: 'TWD',
                displayCurrency: 'NT$ ',
                price: 8000,
                isFocus: false,
                isActive: true,
                renewable: false,
                needsInvoice: true,
              },
            ],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: false,
            purchasable: false,
            discountSupportVendor: [],
            isAddon: false,
            isSubscribed: false,
            hasMorePlans: false,
            sellingTypes: ['token_subscription'],
            freeTrialDays: 0,
            previousPackageType: 'non-renewable_subscription',
            isSelected: false,
          },
          {
            id: 826,
            name: 'Test Plan NT_0317_01 Sub-1YC-1MP-60QQT',
            subName: 'TP NT_0317_01 Sub-1YC-1MP-60QQT',
            description: 'Test Plan NT_0317_01 Sub-1YC-1MP-60QQT',
            longDescription: 'Test Plan NT_0317_01 Sub-1YC-1MP-60QQT',
            designatedQuestion: 20,
            planType: 'renewable',
            priority: 99999,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: -1,
            preDiscountPrice: 0,
            expiredAt: '2022-03-17 15:34:00 +0800',
            questionQuota: 0,
            isUnlimited: false,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 1,
            contractPeriod: 12,
            isContract: true,
            paymentMethods: [],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: false,
            purchasable: true,
            discountSupportVendor: [],
            isAddon: false,
            isSubscribed: false,
            hasMorePlans: false,
            sellingTypes: ['token_subscription'],
            freeTrialDays: 0,
            previousPackageType: 'renewable_subscription',
            isSelected: false,
          },
          {
            id: 827,
            name: 'Test Plan NT_0317_02 Con-1P-60QQT',
            subName: 'TP NT_0317_02 Con-1P-60QQT\t',
            description: 'Test Plan NT_0317_02 Con-1P-60QQT',
            longDescription: 'Test Plan NT_0317_02 Con-1P-60QQT',
            designatedQuestion: 20,
            planType: 'consumable',
            priority: 99999,
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            isSpecialOffer: false,
            isFreeTrial: false,
            isTimeLimited: false,
            registerWithinDays: -1,
            preDiscountPrice: 0,
            expiredAt: '2022-03-17 16:41:00 +0800',
            questionQuota: 0,
            isUnlimited: false,
            billingCyclePerDays: 0,
            billingCyclePerMonths: 1,
            contractPeriod: 0,
            isContract: false,
            paymentMethods: [],
            deliveryType: ['shipping', 'in_store_pickup'],
            isFocus: false,
            purchasable: true,
            discountSupportVendor: [],
            isAddon: false,
            isSubscribed: false,
            hasMorePlans: false,
            sellingTypes: ['token_subscription'],
            freeTrialDays: 0,
            previousPackageType: 'consumable',
            isSelected: false,
          },
        ],
      },
    ],
    liveGroups: {
      storePagePictures: [
        'https://s3-ap-southeast-1.amazonaws.com/attachments.test-consolidation.appedu.co/live_topics/pictures/000/000/001/original/nicola480.png?1623904184',
        'https://s3-ap-southeast-1.amazonaws.com/attachments.test-consolidation.appedu.co/live_topics/pictures/000/000/002/original/12.jpg?1605086345',
        'https://s3-ap-southeast-1.amazonaws.com/attachments.test-consolidation.appedu.co/live_topics/pictures/000/000/003/original/13.jpg?1605086346',
        'https://s3-ap-southeast-1.amazonaws.com/attachments.test-consolidation.appedu.co/live_topics/pictures/000/000/004/original/14.jpg?1605086346',
        'https://s3-ap-southeast-1.amazonaws.com/attachments.test-consolidation.appedu.co/live_topics/pictures/000/000/005/original/15.jpg?1605086346',
        'https://s3-ap-southeast-1.amazonaws.com/attachments.test-consolidation.appedu.co/live_topics/pictures/000/000/006/original/ghost.jpg?1605086347',
        'https://s3-ap-southeast-1.amazonaws.com/attachments.test-consolidation.appedu.co/live_topics/pictures/000/000/007/original/16.png?1605086716',
        'https://s3-ap-southeast-1.amazonaws.com/attachments.test-consolidation.appedu.co/live_topics/pictures/000/000/008/original/17.jpeg?1605086726',
        'https://s3-ap-southeast-1.amazonaws.com/attachments.test-consolidation.appedu.co/live_topics/pictures/000/000/009/original/160404790112_n.png?1607337886',
      ],
      planBillingCycleGroups: [],
    },
    specialOffers: [
      {
        id: 530,
        name: ' (Special Offer) [新手優惠] 學霸產生器 - 前7天免費試用！',
        subName: '每月50題',
        description:
          '根據四年來台灣學生行為設計，單價和總價適中的方案，推薦你採用！',
        longDescription:
          '最後一哩路，推薦給正在衝刺的你最後一哩路，推薦給正在衝刺的你最後一哩路，推薦給正在衝刺的你最後一哩路，推薦給正在衝刺的你最後一哩路，推薦給正在衝刺的你最後一哩路，推薦給正在衝刺的你最後一哩路，推薦給正在衝刺的你最後一哩路，推薦給正在衝刺的你最後一哩路，推薦給正在衝刺的你最後一哩路，推薦給正在衝刺的你最後一哩路，推薦給正在衝刺的你最後一哩路，推薦給正在衝刺的你最後一哩路，推薦給正在衝刺的你最後一哩路，推薦給正在衝刺的你最後一哩路，推薦給正在衝刺的你最後一哩路，推薦給正在衝刺的你最後一哩路，推薦給正在衝刺的你最後一哩路，推薦給正在衝刺的你',
        designatedQuestion: 20,
        planType: 'renewable',
        priority: 87,
        currency: 'TWD',
        displayCurrency: 'NT$ ',
        limitedDate: '2033-04-29 18:00:51 +0800',
        isSpecialOffer: true,
        isFreeTrial: true,
        isTimeLimited: false,
        registerWithinDays: 4000,
        preDiscountPrice: 0,
        expiredAt: '2021-06-23 15:06:00 +0800',
        questionQuota: 0,
        isUnlimited: false,
        billingCyclePerDays: 0,
        billingCyclePerMonths: 1,
        contractPeriod: 0,
        isContract: false,
        paymentMethods: [
          {
            id: 2639,
            platform: 'web',
            sku: 'tw_web_limited_monthly_p1990_q50_2022mar02_6169ab',
            methodType: 'neweb',
            currency: 'TWD',
            displayCurrency: 'NT$ ',
            price: 1990,
            isFocus: false,
            isActive: true,
            renewable: false,
            needsInvoice: true,
          },
        ],
        deliveryType: ['shipping', 'in_store_pickup'],
        isFocus: false,
        purchasable: false,
        discountSupportVendor: [],
        isAddon: false,
        isSubscribed: false,
        hasMorePlans: false,
        sellingTypes: ['token_subscription'],
        freeTrialDays: 7,
        previousPackageType: 'renewable_subscription',
        isSelected: false,
      },
    ],
  },
};

export const checkoutCollection = {
  status: 'success',
  data: {
    checkout_collections: [
      {
        id: 442,
        title: 'MOCK 課程5選3 bundle consumable',
        description: 'MOCK 課程5選3 bundle consumable',
        collection_type: 'bundle',
        has_more_collections: false,
        required_options_count: 3,
        options_count: 5,
        is_presale_expired: true,
        banner_image_url: null,
        banner_url: null,
        presale_start_at: null,
        presale_expired_at: null,
        content_start_at: null,
        presale_price: null,
        plan: {
          id: 770,
          name: 'MOCK 課程5選3 bundle consumable',
          sub_name: '課程5選3 bundle consumable',
          description: '課程5選3 bundle consumable',
          long_description: '課程5選3 bundle consumable',
          highlight: null,
          designated_question: 20,
          plan_type: 'consumable',
          priority: 0,
          currency: 'TWD',
          display_currency: 'NT$ ',
          limited_date: null,
          is_special_offer: false,
          is_free_trial: false,
          is_time_limited: false,
          register_within_days: -1,
          pre_discount_price: 1800.0,
          expired_at: '2021-09-25 22:49:00 +0800',
          question_quota: 0,
          is_unlimited: false,
          billing_cycle_per_days: 0,
          billing_cycle_per_months: 1200,
          contract_period: 0,
          is_contract: false,
          payment_methods: [
            {
              id: 2444,
              platform: 'web',
              sku: 'tw_web_limited_1200monthly_p1000_q0_2021oct26_cb7deb',
              method_type: 'braintree',
              currency: 'TWD',
              display_currency: 'NT$ ',
              price: 1200.0,
              is_focus: false,
              is_active: true,
              renewable: false,
              introductory_price: null,
              needs_invoice: true,
            },
            {
              id: 2445,
              platform: 'web',
              sku: 'tw_web_limited_1200monthly_p1000_q0_2021oct26_2084c0',
              method_type: 'neweb',
              currency: 'TWD',
              display_currency: 'NT$ ',
              price: 1200.0,
              is_focus: false,
              is_active: true,
              renewable: false,
              introductory_price: null,
              needs_invoice: true,
            },
            {
              id: 2446,
              platform: 'web',
              sku:
                'tw_web_premium_unlimited_3monthly_p6590_qunl_2018mar31_cf4f37',
              method_type: 'line_pay',
              currency: 'TWD',
              display_currency: 'NT$ ',
              price: 3000.0,
              is_focus: false,
              is_active: true,
              renewable: false,
              introductory_price: null,
              needs_invoice: true,
            },
          ],
          delivery_type: ['shipping', 'in_store_pickup'],
          is_focus: false,
          purchasable: true,
          discount_support_vendor: [],
          is_addon: false,
          is_subscribed: false,
          has_more_plans: false,
          selling_types: ['course', 'course_subscription'],
          free_trial_days: 0,
          previous_package_type: 'consumable',
          is_selected: true,
        },
      },
    ],
    infos_header: null,
    infos: [],
    courses: [
      {
        id: 83,
        meta_title: 'Sports Day',
        meta_description:
          '穿上外套看著手錶，時間來到心怦怦地跳，和你的第一次約會來臨了，換了新髮膠把頭髮弄好，要你看到我的好～\r\n一個風和日麗的下午，金色的陽光灑在大安森林公園的人行道，森森踏著緊張羞怯的步伐慢慢的走向塔塔⋯',
        content: [],
        title: '課程A: Sports Day (1)',
        hash_tag: '福委會年度鉅獻',
        content_hashtags: ['sport', '預購', '測試'],
        is_recommend: true,
        publisher: 'Snapask',
        exclusive_plan: {
          id: 711,
          name: '課程A single subscription',
          sub_name: '課程A single subscription',
          description: '課程A single subscription',
          long_description: '課程A single subscription',
          plan_type: 'renewable',
          priority: 9999,
          currency: 'TWD',
          display_currency: 'NT$ ',
          limited_date: null,
          is_special_offer: false,
          is_free_trial: false,
          is_time_limited: false,
          register_within_days: -1,
          free_trial_days: 0,
          pre_discount_price: 0.0,
          expired_at: '2021-08-25 23:10:00 +0800',
          question_quota: 0,
          is_unlimited: false,
          billing_cycle_per_days: 0,
          billing_cycle_per_months: 1,
          contract_period: 0,
          is_contract: false,
          payment_methods: [
            {
              id: 2168,
              platform: 'android',
              sku:
                'tw_android_starter_limited_monthly_p600_q0_2021aug25_2234d7',
              method_type: 'braintree',
              currency: 'TWD',
              display_currency: 'NT$ ',
              price: 600.0,
              is_focus: false,
              is_active: true,
              renewable: true,
              introductory_price: null,
              needs_invoice: true,
            },
            {
              id: 2169,
              platform: 'ios',
              sku: 'tw_ios_starter_limited_monthly_p600_q0_2021aug25_f763aa',
              method_type: 'braintree',
              currency: 'TWD',
              display_currency: 'NT$ ',
              price: 600.0,
              is_focus: false,
              is_active: true,
              renewable: true,
              introductory_price: null,
              needs_invoice: true,
            },
            {
              id: 2170,
              platform: 'web',
              sku: 'tw_web_starter_limited_monthly_p600_q0_2021aug25_34ea5f',
              method_type: 'braintree',
              currency: 'TWD',
              display_currency: 'NT$ ',
              price: 600.0,
              is_focus: false,
              is_active: true,
              renewable: true,
              introductory_price: null,
              needs_invoice: true,
            },
            {
              id: 2397,
              platform: 'ios',
              sku: 'tw_ios_limited_monthly_p600_q0_2021oct12_a0ff50',
              method_type: 'apple',
              currency: 'TWD',
              display_currency: 'NT$ ',
              price: 600.0,
              is_focus: false,
              is_active: true,
              renewable: true,
              introductory_price: null,
              needs_invoice: false,
            },
            {
              id: 2398,
              platform: 'android',
              sku: 'tw_android_limited_monthly_p600_q0_2021oct12_730bbc',
              method_type: 'google',
              currency: 'TWD',
              display_currency: 'NT$ ',
              price: 600.0,
              is_focus: false,
              is_active: true,
              renewable: true,
              introductory_price: null,
              needs_invoice: false,
            },
            {
              id: 2805,
              platform: 'redeem',
              sku: 'tw_redeem_limited_monthly_p0_q0_2022apr05_2e8b8e',
              method_type: 'redeem',
              currency: 'TWD',
              display_currency: 'NT$ ',
              price: 0.0,
              is_focus: false,
              is_active: true,
              renewable: false,
              introductory_price: null,
              needs_invoice: false,
            },
            {
              id: 3093,
              platform: 'web',
              sku: 'tw_web_limited_monthly_p600_q0_2022jun06_d04d42',
              method_type: 'neweb',
              currency: 'TWD',
              display_currency: 'NT$ ',
              price: 600.0,
              is_focus: false,
              is_active: true,
              renewable: false,
              introductory_price: null,
              needs_invoice: true,
            },
          ],
          delivery_type: ['shipping', 'in_store_pickup'],
          is_focus: false,
          purchasable: true,
          discount_support_vendor: [],
          is_addon: false,
          selling_types: ['course_subscription'],
        },
        picture: {
          large_url:
            'https://s3-ap-southeast-1.amazonaws.com/attachments.test-consolidation.appedu.co/course/videos/pictures/000/000/083/large/Trista.jpg?1641890128',
          medium_url:
            'https://s3-ap-southeast-1.amazonaws.com/attachments.test-consolidation.appedu.co/course/videos/pictures/000/000/083/medium/Trista.jpg?1641890128',
          thumb_url:
            'https://s3-ap-southeast-1.amazonaws.com/attachments.test-consolidation.appedu.co/course/videos/pictures/000/000/083/thumb/Trista.jpg?1641890128',
          original_url:
            'https://s3-ap-southeast-1.amazonaws.com/attachments.test-consolidation.appedu.co/course/videos/pictures/000/000/083/original/Trista.jpg?1641890128',
        },
        type: 'video',
        lessons_amount: 1,
        total_lessons_duration: 0,
        lessons_video_source: 'vdocipher',
        enroll_status: 'unenrolled',
        instructors: [
          {
            id: 1,
            name: '煉獄杏壽郎 / fire',
            active: false,
            subjects: [
              {
                id: 96,
                abbr: 'Math',
                description: '數學甲',
                minimum_credits_required: 10,
                bg_color: '#73c3e1',
                icon_color: '#ffffff',
                text_color: '#000000',
                is_default: false,
                icon_pic_url:
                  'https://s3-ap-southeast-1.amazonaws.com/attachments.test-consolidation.appedu.co/subjects/icon_pics/000/000/096/medium/96_math%E7%94%B2.png?1485144645',
                topic_count: 0,
                is_show_quizzes: true,
                subject_group_ids: [],
                ask_type: 'normal',
                can_compete: true,
              },
              {
                id: 99,
                abbr: 'English',
                description: '英文',
                minimum_credits_required: 10,
                bg_color: '#888888',
                icon_color: '#ffffff',
                text_color: '#000000',
                is_default: false,
                icon_pic_url:
                  'https://s3-ap-southeast-1.amazonaws.com/attachments.test-consolidation.appedu.co/subjects/icon_pics/000/000/099/medium/99_english.png?1485144693',
                topic_count: 0,
                is_show_quizzes: true,
                subject_group_ids: [],
                ask_type: 'normal',
                can_compete: false,
              },
              {
                id: 102,
                abbr: 'Civic',
                description: '公民',
                minimum_credits_required: 10,
                bg_color: '#888888',
                icon_color: '#ffffff',
                text_color: '#000000',
                is_default: false,
                icon_pic_url:
                  'https://s3-ap-southeast-1.amazonaws.com/attachments.test-consolidation.appedu.co/subjects/icon_pics/000/000/102/medium/102_civicstudies.png?1485144727',
                topic_count: 0,
                is_show_quizzes: false,
                subject_group_ids: [],
                ask_type: 'normal',
                can_compete: false,
              },
              {
                id: 16,
                abbr: 'Math',
                description: '數學',
                minimum_credits_required: 40,
                bg_color: '#73c3e1',
                icon_color: '#000000',
                text_color: '#000000',
                is_default: false,
                icon_pic_url:
                  'https://s3-ap-southeast-1.amazonaws.com/attachments.test-consolidation.appedu.co/subjects/icon_pics/000/000/016/medium/16_math.png?1484902736',
                topic_count: 5,
                is_show_quizzes: true,
                subject_group_ids: [],
                ask_type: 'normal',
                can_compete: false,
              },
            ],
            avatar_url:
              'https://s3-ap-southeast-1.amazonaws.com/attachments.test-consolidation.appedu.co/instructors/avatars/000/000/001/original/fire.png?1635155693',
            url: 'https://www.youtube.com/watch?v=iTW1bv2eO9Y',
            video_source: 'youtube',
            video_id: 'iTW1bv2eO9Y',
            instructor_hashtags: ['炎柱', 'aaa', 'bbb'],
            live_topic_count: 8,
            course_count: 23,
            askable_tutor_id: 126031,
            about: [
              {
                id: 9,
                content: 'test test test',
                icon_url: 'https://i.imgur.com/09tepJj.png',
                description: '• title1\r\n• title2\r\n• title3',
              },
              {
                id: 24,
                content: 'test 2 test 2',
                icon_url: 'https://i.imgur.com/09tepJj.png',
                description: 'test 2\r\ntest 2',
              },
              { id: 41, content: null, icon_url: '', description: '8B0' },
              { id: 42, content: null, icon_url: '', description: '8B0-2' },
              { id: 43, content: null, icon_url: '', description: '8B0-3' },
              { id: 44, content: null, icon_url: '', description: '8B0-4' },
              { id: 45, content: null, icon_url: '', description: '8B0-5' },
              {
                id: 46,
                content: 'create',
                icon_url: 'qqq',
                description: 'create',
              },
              {
                id: 47,
                content: 'TEST BY QAN-1',
                icon_url: 'https://i.imgur.com/Pj0Kuc3.png',
                description: 'TEST BY QAN-2',
              },
              { id: 48, content: null, icon_url: '', description: '8B0-8' },
              { id: 49, content: null, icon_url: '', description: '8B0-9' },
              { id: 50, content: null, icon_url: '', description: '8B0-10' },
              {
                id: 51,
                content: '安安尼好我是測試',
                icon_url: 'https://www.mobile01.com/category.php?id=15',
                description: '安安尼好我是測試\r\n全館八折免運',
              },
              {
                id: 52,
                content: 'hello_world',
                icon_url: 'https://www.mobile01.com/category.php?id=15',
                description: '安安尼好我是測試 testing',
              },
            ],
          },
        ],
      },
      {
        id: 85,
        meta_title: 'Sports Day',
        meta_description:
          '穿上外套看著手錶，時間來到心怦怦地跳，和你的第一次約會來臨了，換了新髮膠把頭髮弄好，要你看到我的好～\r\n一個風和日麗的下午，金色的陽光灑在大安森林公園的人行道，森森踏著緊張羞怯的步伐慢慢的走向塔塔⋯',
        content: [],
        title: '課程C: Sports Day (3)',
        hash_tag: '福委會年度鉅獻',
        content_hashtags: ['預購', '測試'],
        is_recommend: false,
        publisher: 'Snapask',
        exclusive_plan: {
          id: 713,
          name: '課程C single subscription',
          sub_name: '課程C single subscription',
          description: '課程C single subscription',
          long_description: '課程C single subscription',
          plan_type: 'renewable',
          priority: 9999,
          currency: 'TWD',
          display_currency: 'NT$ ',
          limited_date: null,
          is_special_offer: false,
          is_free_trial: false,
          is_time_limited: false,
          register_within_days: -1,
          free_trial_days: 0,
          pre_discount_price: 0.0,
          expired_at: '2021-08-25 23:13:00 +0800',
          question_quota: 0,
          is_unlimited: false,
          billing_cycle_per_days: 0,
          billing_cycle_per_months: 1,
          contract_period: 0,
          is_contract: false,
          payment_methods: [
            {
              id: 2178,
              platform: 'android',
              sku:
                'tw_android_starter_limited_monthly_p600_q0_2021aug25_174f22',
              method_type: 'braintree',
              currency: 'TWD',
              display_currency: 'NT$ ',
              price: 600.0,
              is_focus: false,
              is_active: true,
              renewable: true,
              introductory_price: null,
              needs_invoice: true,
            },
            {
              id: 2180,
              platform: 'web',
              sku: 'tw_web_starter_limited_monthly_p600_q0_2021aug25_986c97',
              method_type: 'braintree',
              currency: 'TWD',
              display_currency: 'NT$ ',
              price: 600.0,
              is_focus: false,
              is_active: true,
              renewable: true,
              introductory_price: null,
              needs_invoice: true,
            },
            {
              id: 2401,
              platform: 'ios',
              sku: 'tw_ios_limited_monthly_p600_q0_2021oct12_d4a3a0',
              method_type: 'apple',
              currency: 'TWD',
              display_currency: 'NT$ ',
              price: 600.0,
              is_focus: false,
              is_active: true,
              renewable: true,
              introductory_price: null,
              needs_invoice: false,
            },
            {
              id: 2402,
              platform: 'android',
              sku: 'tw_android_limited_monthly_p600_q0_2021oct12_41e419',
              method_type: 'google',
              currency: 'TWD',
              display_currency: 'NT$ ',
              price: 600.0,
              is_focus: false,
              is_active: true,
              renewable: true,
              introductory_price: null,
              needs_invoice: false,
            },
          ],
          delivery_type: ['shipping', 'in_store_pickup'],
          is_focus: false,
          purchasable: true,
          discount_support_vendor: [],
          is_addon: false,
          selling_types: ['course_subscription'],
        },
        picture: {
          large_url:
            'https://s3-ap-southeast-1.amazonaws.com/attachments.test-consolidation.appedu.co/course/videos/pictures/000/000/085/large/Trista.jpg?1641890129',
          medium_url:
            'https://s3-ap-southeast-1.amazonaws.com/attachments.test-consolidation.appedu.co/course/videos/pictures/000/000/085/medium/Trista.jpg?1641890129',
          thumb_url:
            'https://s3-ap-southeast-1.amazonaws.com/attachments.test-consolidation.appedu.co/course/videos/pictures/000/000/085/thumb/Trista.jpg?1641890129',
          original_url:
            'https://s3-ap-southeast-1.amazonaws.com/attachments.test-consolidation.appedu.co/course/videos/pictures/000/000/085/original/Trista.jpg?1641890129',
        },
        type: 'video',
        lessons_amount: 1,
        total_lessons_duration: 0,
        lessons_video_source: 'vdocipher',
        enroll_status: 'unenrolled',
        instructors: [
          {
            id: 1,
            name: '煉獄杏壽郎 / fire',
            active: false,
            subjects: [
              {
                id: 96,
                abbr: 'Math',
                description: '數學甲',
                minimum_credits_required: 10,
                bg_color: '#73c3e1',
                icon_color: '#ffffff',
                text_color: '#000000',
                is_default: false,
                icon_pic_url:
                  'https://s3-ap-southeast-1.amazonaws.com/attachments.test-consolidation.appedu.co/subjects/icon_pics/000/000/096/medium/96_math%E7%94%B2.png?1485144645',
                topic_count: 0,
                is_show_quizzes: true,
                subject_group_ids: [],
                ask_type: 'normal',
                can_compete: true,
              },
              {
                id: 99,
                abbr: 'English',
                description: '英文',
                minimum_credits_required: 10,
                bg_color: '#888888',
                icon_color: '#ffffff',
                text_color: '#000000',
                is_default: false,
                icon_pic_url:
                  'https://s3-ap-southeast-1.amazonaws.com/attachments.test-consolidation.appedu.co/subjects/icon_pics/000/000/099/medium/99_english.png?1485144693',
                topic_count: 0,
                is_show_quizzes: true,
                subject_group_ids: [],
                ask_type: 'normal',
                can_compete: false,
              },
              {
                id: 102,
                abbr: 'Civic',
                description: '公民',
                minimum_credits_required: 10,
                bg_color: '#888888',
                icon_color: '#ffffff',
                text_color: '#000000',
                is_default: false,
                icon_pic_url:
                  'https://s3-ap-southeast-1.amazonaws.com/attachments.test-consolidation.appedu.co/subjects/icon_pics/000/000/102/medium/102_civicstudies.png?1485144727',
                topic_count: 0,
                is_show_quizzes: false,
                subject_group_ids: [],
                ask_type: 'normal',
                can_compete: false,
              },
              {
                id: 16,
                abbr: 'Math',
                description: '數學',
                minimum_credits_required: 40,
                bg_color: '#73c3e1',
                icon_color: '#000000',
                text_color: '#000000',
                is_default: false,
                icon_pic_url:
                  'https://s3-ap-southeast-1.amazonaws.com/attachments.test-consolidation.appedu.co/subjects/icon_pics/000/000/016/medium/16_math.png?1484902736',
                topic_count: 5,
                is_show_quizzes: true,
                subject_group_ids: [],
                ask_type: 'normal',
                can_compete: false,
              },
            ],
            avatar_url:
              'https://s3-ap-southeast-1.amazonaws.com/attachments.test-consolidation.appedu.co/instructors/avatars/000/000/001/original/fire.png?1635155693',
            url: 'https://www.youtube.com/watch?v=iTW1bv2eO9Y',
            video_source: 'youtube',
            video_id: 'iTW1bv2eO9Y',
            instructor_hashtags: ['炎柱', 'aaa', 'bbb'],
            live_topic_count: 8,
            course_count: 23,
            askable_tutor_id: 126031,
            about: [
              {
                id: 9,
                content: 'test test test',
                icon_url: 'https://i.imgur.com/09tepJj.png',
                description: '• title1\r\n• title2\r\n• title3',
              },
              {
                id: 24,
                content: 'test 2 test 2',
                icon_url: 'https://i.imgur.com/09tepJj.png',
                description: 'test 2\r\ntest 2',
              },
              { id: 41, content: null, icon_url: '', description: '8B0' },
              { id: 42, content: null, icon_url: '', description: '8B0-2' },
              { id: 43, content: null, icon_url: '', description: '8B0-3' },
              { id: 44, content: null, icon_url: '', description: '8B0-4' },
              { id: 45, content: null, icon_url: '', description: '8B0-5' },
              {
                id: 46,
                content: 'create',
                icon_url: 'qqq',
                description: 'create',
              },
              {
                id: 47,
                content: 'TEST BY QAN-1',
                icon_url: 'https://i.imgur.com/Pj0Kuc3.png',
                description: 'TEST BY QAN-2',
              },
              { id: 48, content: null, icon_url: '', description: '8B0-8' },
              { id: 49, content: null, icon_url: '', description: '8B0-9' },
              { id: 50, content: null, icon_url: '', description: '8B0-10' },
              {
                id: 51,
                content: '安安尼好我是測試',
                icon_url: 'https://www.mobile01.com/category.php?id=15',
                description: '安安尼好我是測試\r\n全館八折免運',
              },
              {
                id: 52,
                content: 'hello_world',
                icon_url: 'https://www.mobile01.com/category.php?id=15',
                description: '安安尼好我是測試 testing',
              },
            ],
          },
        ],
      },
      {
        id: 91,
        meta_title: 'Facebbok',
        meta_description:
          'Facebook 審查，請在 1 個星期內完成審查影片的製作並上傳，不然就休想用 Facebook oauth login',
        content: [],
        title: '課程E: Facebook compliance check screencast',
        hash_tag: '導演\b最新力作',
        content_hashtags: ['預購', '測試'],
        is_recommend: true,
        publisher: 'Snapask',
        exclusive_plan: {
          id: 790,
          name: '課程E single consumable purchase',
          sub_name: '(sub-name) 課程E single consumable purchase',
          description: '(description ) 課程E single consumable purchase',
          long_description:
            '(long description ) 課程E single consumable purchase',
          plan_type: 'consumable',
          priority: 0,
          currency: 'TWD',
          display_currency: 'NT$ ',
          limited_date: null,
          is_special_offer: false,
          is_free_trial: false,
          is_time_limited: false,
          register_within_days: -1,
          free_trial_days: 0,
          pre_discount_price: 0.0,
          expired_at: '2021-12-09 10:22:00 +0800',
          question_quota: 0,
          is_unlimited: false,
          billing_cycle_per_days: 0,
          billing_cycle_per_months: 1,
          contract_period: 0,
          is_contract: false,
          payment_methods: [
            {
              id: 2551,
              platform: 'android',
              sku: 'tw_android_limited_monthly_p1000_q0_2021dec09_44c20e',
              method_type: 'google',
              currency: 'TWD',
              display_currency: 'NT$ ',
              price: 1000.0,
              is_focus: false,
              is_active: true,
              renewable: false,
              introductory_price: null,
              needs_invoice: false,
            },
            {
              id: 2552,
              platform: 'android',
              sku: 'tw_android_limited_monthly_p1000_q0_2021dec09_02bc20',
              method_type: 'braintree',
              currency: 'TWD',
              display_currency: 'NT$ ',
              price: 1000.0,
              is_focus: false,
              is_active: true,
              renewable: false,
              introductory_price: null,
              needs_invoice: true,
            },
            {
              id: 2553,
              platform: 'android',
              sku: 'tw_android_limited_monthly_p1000_q0_2021dec09_e76e9d',
              method_type: 'neweb',
              currency: 'TWD',
              display_currency: 'NT$ ',
              price: 1000.0,
              is_focus: false,
              is_active: true,
              renewable: false,
              introductory_price: null,
              needs_invoice: true,
            },
            {
              id: 2554,
              platform: 'ios',
              sku: 'tw_ios_limited_monthly_p1000_q0_2021dec09_a5899a',
              method_type: 'braintree',
              currency: 'TWD',
              display_currency: 'NT$ ',
              price: 1000.0,
              is_focus: false,
              is_active: true,
              renewable: false,
              introductory_price: null,
              needs_invoice: true,
            },
            {
              id: 2555,
              platform: 'web',
              sku: 'tw_web_limited_monthly_p1000_q0_2021dec09_d87dc6',
              method_type: 'braintree',
              currency: 'TWD',
              display_currency: 'NT$ ',
              price: 1000.0,
              is_focus: false,
              is_active: true,
              renewable: false,
              introductory_price: null,
              needs_invoice: true,
            },
            {
              id: 2556,
              platform: 'web',
              sku: 'tw_web_limited_monthly_p1000_q0_2021dec09_a3c432',
              method_type: 'neweb',
              currency: 'TWD',
              display_currency: 'NT$ ',
              price: 1000.0,
              is_focus: false,
              is_active: true,
              renewable: false,
              introductory_price: null,
              needs_invoice: true,
            },
          ],
          delivery_type: ['shipping', 'in_store_pickup'],
          is_focus: false,
          purchasable: true,
          discount_support_vendor: [],
          is_addon: false,
          selling_types: ['course'],
        },
        picture: {
          large_url:
            'https://s3-ap-southeast-1.amazonaws.com/attachments.test-consolidation.appedu.co/course/videos/pictures/000/000/091/large/facebook.png?1641890133',
          medium_url:
            'https://s3-ap-southeast-1.amazonaws.com/attachments.test-consolidation.appedu.co/course/videos/pictures/000/000/091/medium/facebook.png?1641890133',
          thumb_url:
            'https://s3-ap-southeast-1.amazonaws.com/attachments.test-consolidation.appedu.co/course/videos/pictures/000/000/091/thumb/facebook.png?1641890133',
          original_url:
            'https://s3-ap-southeast-1.amazonaws.com/attachments.test-consolidation.appedu.co/course/videos/pictures/000/000/091/original/facebook.png?1641890133',
        },
        type: 'video',
        lessons_amount: 1,
        total_lessons_duration: 672,
        lessons_video_source: 'vdocipher',
        enroll_status: 'unenrolled',
        instructors: [
          {
            id: 33,
            name: '普林斯丁',
            active: true,
            subjects: [
              {
                id: 96,
                abbr: 'Math',
                description: '數學甲',
                minimum_credits_required: 10,
                bg_color: '#73c3e1',
                icon_color: '#ffffff',
                text_color: '#000000',
                is_default: false,
                icon_pic_url:
                  'https://s3-ap-southeast-1.amazonaws.com/attachments.test-consolidation.appedu.co/subjects/icon_pics/000/000/096/medium/96_math%E7%94%B2.png?1485144645',
                topic_count: 0,
                is_show_quizzes: true,
                subject_group_ids: [],
                ask_type: 'normal',
                can_compete: true,
              },
              {
                id: 16,
                abbr: 'Math',
                description: '數學',
                minimum_credits_required: 40,
                bg_color: '#73c3e1',
                icon_color: '#000000',
                text_color: '#000000',
                is_default: false,
                icon_pic_url:
                  'https://s3-ap-southeast-1.amazonaws.com/attachments.test-consolidation.appedu.co/subjects/icon_pics/000/000/016/medium/16_math.png?1484902736',
                topic_count: 5,
                is_show_quizzes: true,
                subject_group_ids: [],
                ask_type: 'normal',
                can_compete: false,
              },
            ],
            avatar_url:
              'https://s3-ap-southeast-1.amazonaws.com/attachments.test-consolidation.appedu.co/instructors/avatars/000/000/033/original/Prince_Jr.jpg?1633087717',
            url: '',
            video_source: null,
            video_id: null,
            instructor_hashtags: ['prince'],
            live_topic_count: 1,
            course_count: 4,
            askable_tutor_id: 126031,
            about: [],
          },
        ],
      },
    ],
    live_topics: [],
    group_passes: [],
  },
};

export const discountVerified = {
  status: 'success',
  data: {
    code: 'DISCOUNT_MU',
    discount_value: 500.0,
    number_of_billing_cycles: 1,
  },
};

export const buildPending = {
  status: 'success',
  data: {
    payment: {
      plan_name: 'Test - Plan_name_220523',
      order_number: '16551980242968017929',
      writeoff_number: null,
      payment_type: 'line_pay',
      currency: 'TWD',
      display_currency: 'NT$ ',
      amount: '110.0',
      bank_id: null,
      bank_name: null,
      created_at: '2022-06-14 17:13:44 +0800',
      expired_at: null,
      status: 'pending',
      barcode_image: null,
      barcode_image_width: null,
      barcode_image_height: null,
      endpoint: null,
      payload: null,
    },
  },
};

export const linePayUrl = {
  status: 'success',
  data: {
    web:
      'https://sandbox-web-pay.line.me/web/payment/wait?transactionReserveId=TFVMNVZtZ1J5cmNZQmRmRUVIQjY2djJkSzdFTFBHdkFsZWdXNXpwMS9SVjNIUnY1eEJoNzZGVlo1S0k5OG95dA',
    app:
      'line://pay/payment/TFVMNVZtZ1J5cmNZQmRmRUVIQjY2djJkSzdFTFBHdkFsZWdXNXpwMS9SVjNIUnY1eEJoNzZGVlo1S0k5OG95dA',
  },
};

export const checkoutLinePay = {
  status: 'success',
  data: {
    sale_item: {
      id: 71662,
      purchased_package: {
        name: 'Test - Plan_name_220523',
        sub_name: 'Test - Sub_name_220523',
        price: 110.0,
        plan_type: 'consumable',
        package_type: 'consumable',
        payment_type: 'LINE_PAY',
        sku: 'tw_ios_1m_p110_q10_3b83c3',
        description: 'Test - Description_220523',
        long_description: 'Test - Long Description_220523',
        priority: 12345,
        expire_days: 0,
        expire_months: 1,
        trial_duration: 0,
        trial_duration_unit: 'days',
        is_unlimited: false,
        question_quota: 10,
        discount_amount: null,
        display_currency: 'NT$ ',
        background_image_url: '',
        barcode: null,
        is_time_limited: false,
        pre_discount_price: 0.0,
        expired_at: '2022-05-23 15:59:00 +0800',
        testimonial: null,
        delivery_type: ['shipping', 'in_store_pickup'],
        id: 1026,
      },
      start_at: '2022-06-14 17:48:48 +0800',
      expire_at: '2022-07-14 23:59:59 +0800',
      expired_within_seven_days: false,
      question_quota: 10,
      iap_checked_at: '2022-06-14 17:47:23 +0800',
      payment_service_subscription_id: null,
      discount_amount: null,
      cancelled_at: null,
      payment_status: null,
      quotas: [
        {
          id: 325200,
          quotas: 10,
          start_at: '2022-06-14 00:00:00 +0800',
          expire_at: '2022-07-14 23:59:59 +0800',
        },
      ],
      is_upgradable: false,
      payment: {
        plan_name: 'Test - Plan_name_220523',
        order_number: '16552000422968033502',
        writeoff_number: null,
        payment_type: 'line_pay',
        amount: '110.0',
        bank_id: null,
        bank_name: null,
        created_at: '2022-06-14 17:47:22 +0800',
        expired_at: '2022-07-14 23:59:59 +0800',
        currency: 'TWD',
        display_currency: 'NT$ ',
        status: 'success',
        payment_method: {
          id: 3108,
          platform: 'ios',
          sku: 'tw_ios_1m_p110_q10_3b83c3',
          method_type: 'line_pay',
          currency: 'TWD',
          display_currency: 'NT$ ',
          price: 110.0,
          is_focus: false,
          is_active: true,
          renewable: false,
          introductory_price: null,
          needs_invoice: false,
        },
        barcode_image: null,
        barcode_image_width: null,
        barcode_image_height: null,
      },
    },
  },
};



// WEBPACK FOOTER //
// ./app/services/mock/response/purchase.js